(function () {
  'use strict';

  // ─── Constants ───────────────────────────────────────────────────────────────

  var FILAMENTS = [
    { id: 'forge-black',  name: 'Forge Black',  hex: '#1a1a1a' },
    { id: 'chalk-white',  name: 'Chalk White',  hex: '#efe9df' },
    { id: 'raw-brass',    name: 'Raw Brass',    hex: '#c8a96e' },
    { id: 'slate',        name: 'Slate',        hex: '#6b7280' },
    { id: 'navy',         name: 'Navy',         hex: '#1e3a5f' },
    { id: 'forest',       name: 'Forest',       hex: '#2d4a2d' },
    { id: 'terracotta',   name: 'Terracotta',   hex: '#c4622d' },
    { id: 'burgundy',     name: 'Burgundy',     hex: '#6b2233' },
    { id: 'concrete',     name: 'Concrete',     hex: '#9ca3af' },
    { id: 'sand',         name: 'Sand',         hex: '#d4a855' },
  ];

  var BOARD_COLORS = [
    { id: 'board-black', name: 'Black', hex: '#1e1e1e' },
    { id: 'board-white', name: 'White', hex: '#e4e0d8' },
  ];

  var FRAME_COLORS = [
    { id: 'frame-black',  name: 'Black',  hex: '#1a1a1a' },
    { id: 'frame-white',  name: 'White',  hex: '#efe9df' },
    { id: 'frame-gray',   name: 'Gray',   hex: '#6b7280' },
    { id: 'frame-coffee', name: 'Coffee', hex: '#5c3d2e' },
    { id: 'frame-red',    name: 'Red',    hex: '#7a2c2c' },
  ];

  var NP_COLORS = [
    { id: 'matte-black',  name: 'Matte Black',  hex: '#1a1a1a' },
    { id: 'chalk-white',  name: 'Chalk White',  hex: '#efe9df' },
    { id: 'slate-grey',   name: 'Slate Grey',   hex: '#6b7280' },
    { id: 'forest-green', name: 'Forest Green', hex: '#2d4a2d' },
    { id: 'raw-brass',    name: 'Raw Brass',    hex: '#c8a96e' },
  ];

  // Background colors for Core display (dropdown, will be updated with real filament options)
  var BG_COLORS = [
    { id: 'matte-black',  name: 'Matte Black',  hex: '#1a1a1a' },
    { id: 'chalk-white',  name: 'Chalk White',  hex: '#efe9df' },
    { id: 'slate-grey',   name: 'Slate Grey',   hex: '#6b7280' },
    { id: 'forest-green', name: 'Forest Green', hex: '#2d4a2d' },
    { id: 'raw-brass',    name: 'Raw Brass',    hex: '#c8a96e' },
  ];

  var TEXT_COLORS = [
    { id: 'white',    name: 'White',    hex: '#f5f0e8' },
    { id: 'black',    name: 'Black',    hex: '#0e0e0e' },
    { id: 'brass',    name: 'Brass',    hex: '#c8a96e' },
    { id: 'charcoal', name: 'Charcoal', hex: '#4a4a4a' },
    { id: 'cream',    name: 'Cream',    hex: '#f0e6d2' },
  ];

  var FONTS = [
    { id: 'helvetica', name: 'Classic',   css: 'Helvetica Neue, Arial, sans-serif' },
    { id: 'georgia',   name: 'Elegant',   css: 'Georgia, serif' },
    { id: 'impact',    name: 'Bold',      css: 'Impact, sans-serif' },
    { id: 'courier',   name: 'Typewriter', css: '"Courier New", monospace' },
    { id: 'script',    name: 'Script',    css: '"Brush Script MT", "Segoe Script", cursive' },
  ];

  var CORE_PRICES  = { S: 69, M: 79, L: 99 };
  var PRO_PRICES   = { standard: 169, moss: 214 };
  var ADDON_PRICES = { nfcEmbed: 25, keychain: 19, keychain3pack: 49, bizcard: 29 };

  var NP_FREE_LIMIT  = 12;
  var NP_EXTRA_PRICES = { small: 3, medium: 5, large: 7 };

  // ─── Builder Class ────────────────────────────────────────────────────────────

  function SSMadeDisplayBuilder(el) {
    this.el = el;
    this.products = {};
    try { this.products = JSON.parse(el.dataset.products || '{}'); } catch (e) {}

    this.mode = el.dataset.defaultMode || 'core';

    this.core = {
      size: 'M', corner: 'standard', bgColorId: 'matte-black',
      textBlocks: [], selected: null,
      addons: { nfcEmbed: false, keychain: false, bizcard: false },
      keychainType: 'single',
      bizcardText: '',
    };

    this.pro = {
      variant: 'standard',
      orientation: 'portrait',
      boardColorId: 'board-black',
      frameColorId: 'frame-black',
      npColorId: 'matte-black',
      nameplates: [], selected: null, nameplateSize: 'medium',
      addons: { keychain: false, bizcard: false },
      keychainType: 'single',
      bizcardText: '',
    };

    this.nm = {
      items: [], selected: null, nameplateSize: 'medium', page: 0,
    };

    this._nmPositions = [];
    this._rapidAssembly = false;
    this._proStep1Done = false;
    this._proStep2Done = false;
    this._coreStep1Done = false;
    this._coreStep2Done = false;
    this._coreStep3Done = false;

    this.dragging = null;
    this.dragOff  = { x: 0, y: 0 };

    this.canvas = el.querySelector('#dsb-canvas');
    this.ctx    = this.canvas ? this.canvas.getContext('2d') : null;

    if (!this.canvas || !this.ctx) return;

    this.W = 640;
    this.H = 640;
    this.canvas.width  = 640;
    this.canvas.height = 640;

    this._init();
  }

  SSMadeDisplayBuilder.prototype = {

    _init: function () {
      document.title = 'Display Builder \u2014 SSMade';
      this._bindMode();
      this._bindColorSwatches();
      this._bindMobileHeader();
      this._bindCoreSidebar();
      this._bindProSidebar();
      this._bindNmSidebar();
      this._bindPropsPanel();
      this._bindCanvas();
      this._bindAtc();
      this._bindRapid();
      this._bindBoardNav();
      this._bindDraft();
      this._initFromUrl();
      this._buildMobileStickyBar();
      this._buildReassuranceModal();
      this._bindCanvasCta();
      this._bindCoreCta();
      this._checkDraftResume();
      this.render();
      this._updatePrice();
      this._updateCoreCta();
      this._updateCoreStylePreview();
      this._updateStepProgress();
    },

    // ── URL Parameter Routing & Templates ────────────────────────────────────

    _TEMPLATES: {
      barber: {
        product: 'pro', variant: 'standard', orientation: 'portrait',
        boardColor: 'board-black', npColor: 'chalk-white',
        nameplates: [
          { text: 'CUTS', size: 'medium' },
          { text: 'FADES', size: 'medium' },
          { text: 'BEARD TRIMS', size: 'large' },
          { text: 'WALK-INS WELCOME', size: 'large' },
          { text: 'BOOK NOW \u2193', size: 'medium' },
        ],
        hint: 'This is your Barbershop layout \u2014 tap any nameplate to customize it.',
      },
      farmersmarket: {
        product: 'pro', variant: 'moss', orientation: 'landscape',
        boardColor: 'board-white', npColor: 'forest-green',
        nameplates: [
          { text: 'TODAY\'S SPECIALS', size: 'large', npColorId: 'forest-green' },
          { text: 'FRESH PICKED', size: 'medium', npColorId: 'chalk-white' },
          { text: '[YOUR FARM NAME]', size: 'large', npColorId: 'chalk-white' },
          { text: '$5', size: 'small', npColorId: 'forest-green' },
          { text: '$8', size: 'small', npColorId: 'forest-green' },
          { text: '$12', size: 'small', npColorId: 'forest-green' },
        ],
        hint: 'This is your Farmers Market layout \u2014 tap any nameplate to customize it.',
      },
      foodtruck: {
        product: 'pro', variant: 'standard', orientation: 'portrait',
        boardColor: 'board-black', npColor: 'chalk-white',
        nameplates: [
          { text: 'TODAY\'S MENU', size: 'large' },
          { text: 'TACOS', size: 'medium' },
          { text: 'BURRITOS', size: 'medium' },
          { text: 'DRINKS', size: 'medium' },
          { text: 'FOLLOW US \u2193', size: 'medium' },
        ],
        hint: 'This is your Food Truck layout \u2014 tap any nameplate to customize it.',
      },
      coffeeshop: {
        product: 'pro', variant: 'moss', orientation: 'portrait',
        boardColor: 'board-black', npColor: 'chalk-white',
        nameplates: [
          { text: 'SPECIALS', size: 'large', npColorId: 'chalk-white' },
          { text: 'POUR OVER', size: 'medium', npColorId: 'matte-black' },
          { text: 'COLD BREW', size: 'medium', npColorId: 'chalk-white' },
          { text: 'SEASONAL LATTE', size: 'large', npColorId: 'matte-black' },
          { text: 'TIP JAR \u2193', size: 'medium', npColorId: 'chalk-white' },
        ],
        hint: 'This is your Coffee Shop layout \u2014 tap any nameplate to customize it.',
      },
      nailsalon: {
        product: 'core', size: 'M', corner: 'rounded', bgColor: 'chalk-white',
        text: 'WELCOME TO [SALON NAME]',
        hint: 'This is your Nail Salon layout \u2014 tap the text to customize it.',
      },
      boutique: {
        product: 'core', size: 'L', corner: 'arch', bgColor: 'raw-brass',
        text: '[BOUTIQUE NAME] \u2014 EST. 2024',
        hint: 'This is your Boutique layout \u2014 tap the text to customize it.',
      },
      'barber-core': {
        product: 'core', size: 'M', corner: 'standard', bgColor: 'matte-black',
        text: '[SHOP NAME]',
        hint: 'This is your Barbershop Core layout \u2014 tap the text to customize it.',
      },
      brewery: {
        product: 'pro', variant: 'moss', orientation: 'landscape',
        boardColor: 'board-black', npColor: 'chalk-white',
        nameplates: [
          { text: 'ON TAP', size: 'large', npColorId: 'chalk-white' },
          { text: 'HOUSE IPA', size: 'medium', npColorId: 'forest-green' },
          { text: 'AMBER ALE', size: 'medium', npColorId: 'raw-brass' },
          { text: 'STOUT', size: 'medium', npColorId: 'matte-black' },
          { text: 'SEASONAL', size: 'medium', npColorId: 'chalk-white' },
          { text: 'FLIGHTS AVAILABLE', size: 'large', npColorId: 'chalk-white' },
        ],
        hint: 'This is your Brewery/Taproom layout \u2014 tap any nameplate to customize it.',
      },
      'craft-market': {
        product: 'pro', variant: 'standard', orientation: 'portrait',
        boardColor: 'board-white', npColor: 'matte-black',
        nameplates: [
          { text: '[YOUR BRAND]', size: 'large', npColorId: 'matte-black' },
          { text: 'HANDMADE', size: 'medium', npColorId: 'raw-brass' },
          { text: 'SMALL BATCH', size: 'medium', npColorId: 'matte-black' },
          { text: 'PRICES', size: 'medium', npColorId: 'chalk-white' },
          { text: 'FOLLOW US \u2193', size: 'medium', npColorId: 'raw-brass' },
        ],
        hint: 'This is your Craft Market layout \u2014 tap any nameplate to customize it.',
      },
      'popup-shop': {
        product: 'pro', variant: 'standard', orientation: 'landscape',
        boardColor: 'board-black', npColor: 'raw-brass',
        nameplates: [
          { text: 'POP-UP SHOP', size: 'large', npColorId: 'raw-brass' },
          { text: 'NEW ARRIVALS', size: 'medium', npColorId: 'chalk-white' },
          { text: 'LIMITED EDITION', size: 'medium', npColorId: 'raw-brass' },
          { text: 'SHOP NOW', size: 'large', npColorId: 'chalk-white' },
        ],
        hint: 'This is your Pop-Up Shop layout \u2014 tap any nameplate to customize it.',
      },
      'trade-show': {
        product: 'pro', variant: 'standard', orientation: 'landscape',
        boardColor: 'board-black', npColor: 'chalk-white',
        nameplates: [
          { text: '[COMPANY NAME]', size: 'large', npColorId: 'chalk-white' },
          { text: 'BOOTH #___', size: 'medium', npColorId: 'raw-brass' },
          { text: 'PRODUCT 1', size: 'medium', npColorId: 'chalk-white' },
          { text: 'PRODUCT 2', size: 'medium', npColorId: 'chalk-white' },
          { text: 'SCAN FOR INFO \u2193', size: 'medium', npColorId: 'raw-brass' },
        ],
        hint: 'This is your Trade Show layout \u2014 tap any nameplate to customize it.',
      },
      salon: {
        product: 'core', size: 'L', corner: 'rounded', bgColor: 'chalk-white',
        text: '[SALON NAME] \u2022 BOOK NOW',
        hint: 'This is your Salon/Spa layout \u2014 tap the text to customize it.',
      },
      'boutique-retail': {
        product: 'core', size: 'M', corner: 'arch', bgColor: 'matte-black',
        text: '[STORE NAME]',
        hint: 'This is your Boutique Retail layout \u2014 tap the text to customize it.',
      },
    },

    _initFromUrl: function () {
      var self = this;
      var params = new URLSearchParams(window.location.search);
      var product = params.get('product');
      var template = params.get('template');
      var niche = params.get('niche');
      var isUnified = this.el.dataset.unified === 'true';

      // Store chosen product for wizard step 2
      this._wizardProduct = null;

      if (!isUnified) {
        // Non-unified (product page): just apply template/product if present
        if (template && this._TEMPLATES[template]) { this._applyTemplate(template); return; }
        if (product) { this._applyProductParam(product); }
        return;
      }

      // ── Flow 1: Direct template link — skip wizard entirely
      if (template && this._TEMPLATES[template]) {
        this._showBuilder();
        this._applyTemplate(template);
        return;
      }

      // ── Flow 2: Niche param — select product in step 1, auto-apply niche template on enter
      if (niche) {
        this._pendingNiche = niche;
      }

      // ── Flow 3: Product param — skip step 1, go straight to step 2
      if (product) {
        this._wizardProduct = product;
        this._bindWizard();
        this._showWizardStep(2, product);
        return;
      }

      // ── Flow 4: No params — start at step 1
      this._bindWizard();
    },

    // Template definitions per product for wizard step 2
    _PRODUCT_TEMPLATES: {
      pro: [
        { id: 'barber',        label: 'Barbershop' },
        { id: 'farmersmarket', label: 'Farmers Market' },
        { id: 'foodtruck',     label: 'Food Truck' },
        { id: 'coffeeshop',    label: 'Coffee Shop' },
        { id: 'brewery',       label: 'Brewery / Taproom' },
        { id: 'craft-market',  label: 'Craft Market' },
        { id: 'popup-shop',    label: 'Pop-Up Shop' },
        { id: 'trade-show',    label: 'Trade Show' },
      ],
      core: [
        { id: 'nailsalon',       label: 'Nail Salon' },
        { id: 'boutique',        label: 'Boutique' },
        { id: 'barber-core',     label: 'Barbershop' },
        { id: 'salon',           label: 'Salon / Spa' },
        { id: 'boutique-retail', label: 'Retail Store' },
      ],
      nameplates: [],
      'nfc-card': [],
      'nfc-keychain': [],
    },

    _bindWizard: function () {
      var self = this;
      var wizard = document.querySelector('[data-build-wizard]');
      if (!wizard) return;

      var cards = wizard.querySelectorAll('[data-choose]');
      var continueWrap = wizard.querySelector('[data-chooser-continue]');
      var continueBtn = wizard.querySelector('[data-chooser-continue-btn]');
      var continueName = wizard.querySelector('[data-chooser-continue-name]');
      var heroImgs = wizard.querySelectorAll('[data-hero-img]');
      var heroPlaceholder = wizard.querySelector('[data-hero-placeholder]');

      var productNames = {
        pro: 'Pro Display', core: 'Core Display', nameplates: 'Nameplates',
        'nfc-card': 'NFC Business Card', 'nfc-keychain': 'NFC Keychain'
      };

      // Handle hero image load errors — show placeholder SVG as fallback
      heroImgs.forEach(function (img) {
        img.addEventListener('error', function () { img.style.display = 'none'; });
        img.addEventListener('load', function () {
          var zone = wizard.querySelector('[data-hero-zone]');
          if (zone) zone.classList.add('dsb__hero-zone--has-img');
        });
      });

      // Default selection state (pro is pre-selected)
      self._wizardProduct = 'pro';

      // Step 1: product cards — select (highlight) without advancing
      cards.forEach(function (card) {
        card.addEventListener('click', function () {
          var product = card.dataset.choose;
          self._wizardProduct = product;

          // Update card selection states
          cards.forEach(function (c) { c.classList.remove('dsb__chooser-card--selected'); });
          card.classList.add('dsb__chooser-card--selected');

          // Update hero image
          heroImgs.forEach(function (img) {
            img.classList.toggle('dsb__hero-img--active', img.dataset.heroImg === product);
          });
          // Update placeholder text
          if (heroPlaceholder) {
            var placeholderText = heroPlaceholder.querySelector('text');
            if (placeholderText) placeholderText.textContent = (productNames[product] || 'DISPLAY').toUpperCase();
          }

          // Show continue button with product name
          if (continueName) continueName.textContent = productNames[product] || product;
          if (continueWrap) continueWrap.classList.add('dsb__chooser-continue--visible');
        });
      });

      // Continue button — advances to step 2 or builder
      if (continueBtn) {
        continueBtn.addEventListener('click', function () {
          var product = self._wizardProduct;
          if (!product) return;

          // If niche param, skip step 2 and go straight to builder
          if (self._pendingNiche) {
            self._enterBuilderFromWizard(product, self._pendingNiche);
            return;
          }
          // NFC products and nameplates have no templates — go straight to builder
          var templates = self._PRODUCT_TEMPLATES[product];
          if (!templates || templates.length === 0) {
            self._enterBuilderFromWizard(product, null);
            return;
          }
          self._showWizardStep(2, product);
        });
      }

      // Show continue button on load since pro is pre-selected
      if (continueWrap) {
        requestAnimationFrame(function () {
          continueWrap.classList.add('dsb__chooser-continue--visible');
        });
      }

      // Step 2: back button
      var backBtn = wizard.querySelector('[data-wizard-back]');
      if (backBtn) {
        backBtn.addEventListener('click', function () {
          self._showWizardStep(1);
        });
      }
    },

    _showWizardStep: function (step, product) {
      // Any time the wizard is shown (either step), clear any lingering template hints
      this._clearTemplateHints();
      var wizard = document.querySelector('[data-build-wizard]');
      if (!wizard) return;
      var s1 = wizard.querySelector('[data-wizard-step="1"]');
      var s2 = wizard.querySelector('[data-wizard-step="2"]');

      if (step === 1) {
        s1.classList.remove('dsb__wizard-step--hidden');
        s2.classList.add('dsb__wizard-step--hidden');
      } else {
        s1.classList.add('dsb__wizard-step--hidden');
        s2.classList.remove('dsb__wizard-step--hidden');
        this._populateTemplateStep(product);
      }
    },

    _populateTemplateStep: function (product) {
      var self = this;
      var container = document.querySelector('[data-wizard-templates]');
      if (!container) return;

      var productNames = { pro: 'Pro Display', core: 'Core Display', nameplates: 'Nameplates', 'nfc-card': 'NFC Business Card', 'nfc-keychain': 'NFC Keychain' };
      var subEl = document.querySelector('[data-wizard-step2-sub]');
      if (subEl) subEl.textContent = 'Pick a template for your ' + (productNames[product] || 'display') + ', or start from scratch.';

      var templates = this._PRODUCT_TEMPLATES[product] || [];
      var html = '';

      // "Start Blank" card always first
      html += '<button class="dsb__wizard-tmpl-card dsb__wizard-tmpl-card--blank" data-wizard-tmpl="">' +
        '<div class="dsb__wizard-tmpl-preview dsb__wizard-tmpl-preview--blank"><span>+</span></div>' +
        '<span class="dsb__wizard-tmpl-label">Start Blank</span>' +
        '</button>';

      templates.forEach(function (t) {
        html += '<button class="dsb__wizard-tmpl-card" data-wizard-tmpl="' + t.id + '">' +
          '<canvas class="dsb__wizard-tmpl-preview" data-tmpl-canvas="' + t.id + '" width="160" height="120"></canvas>' +
          '<span class="dsb__wizard-tmpl-label">' + t.label + '</span>' +
          '</button>';
      });

      container.innerHTML = html;

      // Render mini preview on each canvas
      templates.forEach(function (t) {
        var cvs = container.querySelector('[data-tmpl-canvas="' + t.id + '"]');
        if (cvs) self._renderTemplatePreview(cvs, t.id);
      });

      // Bind template card clicks
      container.querySelectorAll('[data-wizard-tmpl]').forEach(function (card) {
        card.addEventListener('click', function () {
          var tmplId = card.dataset.wizardTmpl;
          self._enterBuilderFromWizard(product, tmplId || null);
        });
      });
    },

    _renderTemplatePreview: function (cvs, templateId) {
      var t = this._TEMPLATES[templateId];
      if (!t || !cvs) return;
      var ctx = cvs.getContext('2d');
      var w = cvs.width, h = cvs.height;

      // Background
      ctx.fillStyle = '#111';
      ctx.fillRect(0, 0, w, h);

      if (t.product === 'pro') {
        // Draw miniature frame
        var isLand = t.orientation === 'landscape';
        var fw = isLand ? w * 0.82 : w * 0.55;
        var fh = isLand ? h * 0.72 : h * 0.82;
        var fx = (w - fw) / 2;
        var fy = (h - fh) / 2;

        // Frame border
        var fHex = '#1a1a1a';
        if (t.variant === 'moss') {
          ctx.fillStyle = '#2d4a2d';
          ctx.fillRect(fx, fy, fw, fh);
          ctx.fillStyle = fHex;
          ctx.fillRect(fx + 4, fy + 4, fw - 8, fh - 8);
        } else {
          ctx.fillStyle = fHex;
          ctx.fillRect(fx, fy, fw, fh);
        }

        // Board
        var boardHex = t.boardColor === 'board-white' ? '#e4e0d8' : '#1e1e1e';
        var bx = fx + 6, by = fy + 6, bw = fw - 12, bh = fh - 12;
        ctx.fillStyle = boardHex;
        ctx.fillRect(bx, by, bw, bh);

        // Mini nameplates
        if (t.nameplates) {
          var npY = by + 6;
          t.nameplates.forEach(function (np) {
            var npH = np.size === 'large' ? 10 : np.size === 'small' ? 5 : 7;
            var npW = np.size === 'large' ? bw * 0.7 : np.size === 'small' ? bw * 0.25 : bw * 0.5;
            var npX = bx + (bw - npW) / 2;
            if (npY + npH > by + bh - 4) return;
            var npC = NP_COLORS.filter(function (c) { return c.id === (np.npColorId || t.npColor); })[0];
            ctx.fillStyle = npC ? npC.hex : '#efe9df';
            ctx.beginPath();
            ctx.roundRect(npX, npY, npW, npH, 2);
            ctx.fill();
            npY += npH + 3;
          });
        }
      } else if (t.product === 'core') {
        // Draw miniature core display
        var bgC = BG_COLORS.filter(function (c) { return c.id === t.bgColor; })[0];
        var bgHex = bgC ? bgC.hex : '#1a1a1a';
        var cw = w * 0.5, ch = h * 0.75;
        var cx = (w - cw) / 2, cy = (h - ch) / 2;
        var rad = t.corner === 'rounded' ? 8 : t.corner === 'arch' ? 0 : 2;
        ctx.fillStyle = bgHex;
        if (t.corner === 'arch') {
          ctx.beginPath();
          ctx.moveTo(cx, cy + ch * 0.35);
          ctx.quadraticCurveTo(cx, cy, cx + cw / 2, cy);
          ctx.quadraticCurveTo(cx + cw, cy, cx + cw, cy + ch * 0.35);
          ctx.lineTo(cx + cw, cy + ch);
          ctx.lineTo(cx, cy + ch);
          ctx.closePath();
          ctx.fill();
        } else {
          ctx.beginPath();
          ctx.roundRect(cx, cy, cw, ch, rad);
          ctx.fill();
        }
        // Text preview line
        var textC = bgHex === '#1a1a1a' ? 'rgba(245,240,232,0.6)' : 'rgba(14,14,14,0.4)';
        ctx.fillStyle = textC;
        ctx.fillRect(cx + cw * 0.15, cy + ch * 0.42, cw * 0.7, 3);
        ctx.fillRect(cx + cw * 0.25, cy + ch * 0.52, cw * 0.5, 2);
      }
    },

    _enterBuilderFromWizard: function (product, templateId) {
      var modeMap = { pro: 'pro', core: 'core', nameplates: 'nameplates', 'nfc-card': 'core', 'nfc-keychain': 'core' };
      var mode = modeMap[product] || product;

      this._showBuilder();
      this._switchMode(mode);

      // Auto-enable addons for NFC products
      if (product === 'nfc-card') {
        this.core.addons.bizcard = true;
        var r = this.el.querySelector('[data-addon="bizcard"]');
        if (r) r.classList.add('active');
        var sub = this.el.querySelector('[data-addon-sub="bizcard"]');
        if (sub) sub.style.display = 'block';
      } else if (product === 'nfc-keychain') {
        this.core.addons.keychain = true;
        var r2 = this.el.querySelector('[data-addon="keychain"]');
        if (r2) r2.classList.add('active');
        var sub2 = this.el.querySelector('[data-addon-sub="keychain"]');
        if (sub2) sub2.style.display = 'block';
      }

      // Apply template if one was chosen (or niche match)
      if (templateId && this._TEMPLATES[templateId]) {
        this._applyTemplate(templateId);
      } else if (this._pendingNiche) {
        // Check if there's a matching template for the niche
        var nicheMap = {
          barber: 'barber', barbershop: 'barber',
          farmersmarket: 'farmersmarket', farmers: 'farmersmarket',
          foodtruck: 'foodtruck', food: 'foodtruck',
          coffeeshop: 'coffeeshop', coffee: 'coffeeshop', cafe: 'coffeeshop',
          nailsalon: 'nailsalon', nails: 'nailsalon', salon: 'nailsalon',
          boutique: 'boutique', retail: 'boutique',
        };
        var nicheTemplate = nicheMap[this._pendingNiche.toLowerCase()];
        if (nicheTemplate && this._TEMPLATES[nicheTemplate]) {
          this._applyTemplate(nicheTemplate);
        }
      }

      this.render();
      this._updatePrice();
      this._updateStepProgress();
      this._updateProNameplateAccess();

      // Update URL
      var url = new URL(window.location);
      url.searchParams.set('product', product);
      if (templateId) url.searchParams.set('template', templateId);
      window.history.replaceState({}, '', url);
    },

    _applyProductParam: function (product) {
      var modeMap = { pro: 'pro', core: 'core', nameplates: 'nameplates', 'nfc-card': 'core', 'nfc-keychain': 'core' };
      var targetMode = modeMap[product];
      if (targetMode && targetMode !== this.mode) this._switchMode(targetMode);
      if (product === 'nfc-card') {
        this.core.addons.bizcard = true;
        var r = this.el.querySelector('[data-addon="bizcard"]'); if (r) r.classList.add('active');
        var s = this.el.querySelector('[data-addon-sub="bizcard"]'); if (s) s.style.display = 'block';
      } else if (product === 'nfc-keychain') {
        this.core.addons.keychain = true;
        var r2 = this.el.querySelector('[data-addon="keychain"]'); if (r2) r2.classList.add('active');
        var s2 = this.el.querySelector('[data-addon-sub="keychain"]'); if (s2) s2.style.display = 'block';
      }
      // Check for addon params
      var params = new URLSearchParams(window.location.search);
      var addon = params.get('addon');
      if (addon === 'nfc') {
        if (this.mode === 'core') this.core.addons.nfcEmbed = true;
        var addonRow = this.el.querySelector('[data-addon="nfcEmbed"]');
        if (addonRow) addonRow.classList.add('active');
      }
    },

    _showBuilder: function () {
      var wizard = document.querySelector('[data-build-wizard]');
      if (wizard) wizard.style.display = 'none';
      var hdr = document.querySelector('[data-builder-hdr]');
      if (hdr) hdr.classList.remove('dsb__panel--hidden');
      this.el.classList.remove('dsb__panel--hidden');
      var switcher = document.querySelector('[data-product-switcher]');
      if (switcher) switcher.classList.remove('dsb__panel--hidden');
      // Scroll to top of builder so user starts at step 1
      window.scrollTo({ top: 0, behavior: 'smooth' });
    },

    _clearTemplateHints: function () {
      // Scope to document because the hint is inserted as a sibling of .dsb__hdr
      // (which lives outside this.el in some page layouts).
      document.querySelectorAll('.dsb__template-hint').forEach(function (n) {
        if (n.parentNode) n.parentNode.removeChild(n);
      });
    },

    _switchMode: function (newMode) {
      // Clear any leftover template hint when switching modes / returning to funnel
      this._clearTemplateHints();
      this.mode = newMode;
      // Sync all mode buttons (product switcher cards + any inline buttons)
      document.querySelectorAll('[data-mode]').forEach(function (b) {
        b.classList.toggle('active', b.dataset.mode === newMode);
      });
      this.el.querySelectorAll('[data-panel]').forEach(function (p) {
        p.classList.toggle('dsb__panel--hidden', p.dataset.panel.indexOf(newMode) !== 0);
      });
      this.el.querySelectorAll('[data-mode-info]').forEach(function (p) {
        p.classList.toggle('dsb__panel--hidden', p.dataset.modeInfo !== newMode);
      });
      // Sync mobile header tabs
      document.querySelectorAll('[data-mobile-tab]').forEach(function (t) {
        t.classList.toggle('active', t.dataset.mobileTab === newMode);
      });
      // Update mobile header product label
      var labelEl = document.querySelector('[data-builder-product-label]');
      if (labelEl) {
        var names = { pro: 'Pro Display', core: 'Core Display', nameplates: 'Nameplates' };
        labelEl.textContent = names[newMode] || 'Display Builder';
      }
      // Update active mode data attribute for CSS selectors
      this.el.setAttribute('data-active-mode', newMode);
      // Close any open slideup panels when switching modes
      this._closeNpPanel();
      var textPanel = this.el.querySelector('.dsb__text-slideup');
      if (textPanel) this._closeTextPanel();
      // Update mobile bar visibility
      this._updateMobileBar();
      // Re-evaluate step gating (canvas lock depends on mode)
      this._updateStepProgress();
    },

    _applyTemplate: function (templateId) {
      var t = this._TEMPLATES[templateId];
      if (!t) return;

      // Switch to the correct product mode
      if (t.product === 'pro') {
        this._switchMode('pro');
        this._proStep1Done = true;
        this._proStep2Done = true;

        // Apply pro settings
        if (t.variant) {
          this.pro.variant = t.variant;
          this.el.querySelectorAll('[data-variant]').forEach(function (b) {
            b.classList.toggle('active', b.dataset.variant === t.variant);
          });
        }
        if (t.orientation) {
          this.pro.orientation = t.orientation;
          this.el.querySelectorAll('[data-orient]').forEach(function (b) {
            b.classList.toggle('active', b.dataset.orient === t.orientation);
          });
        }
        if (t.boardColor) {
          this.pro.boardColorId = t.boardColor;
          this.el.querySelectorAll('[data-board-color]').forEach(function (b) {
            b.classList.toggle('active', b.dataset.boardColor === t.boardColor);
          });
          var boardLabel = this.el.querySelector('[data-board-color-label]');
          if (boardLabel) {
            var activeBtn = this.el.querySelector('[data-board-color="' + t.boardColor + '"]');
            if (activeBtn) boardLabel.textContent = activeBtn.getAttribute('title');
          }
        }
        if (t.npColor) {
          this.pro.npColorId = t.npColor;
          this.el.querySelectorAll('[data-np-color]').forEach(function (b) {
            b.classList.toggle('active', b.dataset.npColor === t.npColor);
          });
          var npLabel = this.el.querySelector('[data-np-color-label]');
          if (npLabel) {
            var activeNpBtn = this.el.querySelector('[data-np-color="' + t.npColor + '"]');
            if (activeNpBtn) npLabel.textContent = activeNpBtn.getAttribute('title');
          }
        }

        // Add template nameplates
        if (t.nameplates) {
          var self = this;
          var board = this._getBoardRect();
          this.pro.nameplates = [];
          t.nameplates.forEach(function (np, i) {
            self.pro.nameplates.push({
              id: Date.now() + i,
              text: np.text,
              x: board.x + board.w / 2,
              y: board.y + 40 + i * 52,
              size: np.size || 'medium',
              corner: 'rounded',
              font: 'helvetica',
              textSize: 16,
              bold: false, italic: false,
              colorId: 'white',
              npColorId: np.npColorId || t.npColor || 'chalk-white',
              nfc: false, nfcUrl: '',
            });
          });
          this._renderProNpList();
          this._updateNpCounter();
        }

      } else if (t.product === 'core') {
        this._switchMode('core');
        this._coreStep1Done = true;
        this._coreStep2Done = true;
        this._coreStep3Done = true;

        if (t.size) {
          this.core.size = t.size;
          this.el.querySelectorAll('[data-size]').forEach(function (b) {
            b.classList.toggle('active', b.dataset.size === t.size);
          });
        }
        if (t.corner) {
          this.core.corner = t.corner;
          this.el.querySelectorAll('[data-corner]').forEach(function (b) {
            b.classList.toggle('active', b.dataset.corner === t.corner);
          });
        }
        if (t.bgColor) {
          this.core.bgColorId = t.bgColor;
          this.el.querySelectorAll('[data-bg-color]').forEach(function (b) {
            b.classList.toggle('active', b.dataset.bgColor === t.bgColor);
          });
          var bgLabel = this.el.querySelector('[data-bg-color-label]');
          if (bgLabel) {
            var activeBgBtn = this.el.querySelector('[data-bg-color="' + t.bgColor + '"]');
            if (activeBgBtn) bgLabel.textContent = activeBgBtn.getAttribute('title');
          }
        }
        if (t.text) {
          var textBlock = {
            id: Date.now(), text: t.text,
            x: this.W / 2, y: this.H / 2,
            font: 'helvetica', size: 22,
            bold: false, italic: false, colorId: 'white',
          };
          this.core.textBlocks = [textBlock];
          this.core.selected = textBlock.id;
          this._renderCoreTextList();
        }
      }

      // Remove any previous template hints before showing a new one
      this._clearTemplateHints();
      // Show template hint if applicable
      if (t.hint) {
        var hintEl = document.createElement('div');
        hintEl.className = 'dsb__template-hint';
        hintEl.textContent = t.hint;
        var hdr = this.el.querySelector('.dsb__hdr') || this.el;
        if (hdr.nextSibling) {
          hdr.parentNode.insertBefore(hintEl, hdr.nextSibling);
        } else {
          hdr.parentNode.appendChild(hintEl);
        }
      }

      this.render();
      this._updatePrice();
      this._updateStepProgress();
    },

    // ── Mobile Sticky Bottom Bar ─────────────────────────────────────────────

    _buildMobileStickyBar: function () {
      var self = this;
      var bar = document.createElement('div');
      bar.className = 'dsb__mobile-bar';
      bar.innerHTML =
        '<div class="dsb__mobile-bar-top">' +
          '<label class="dsb__mobile-bar-rapid">' +
            '<input type="checkbox" class="dsb__mobile-rapid-cb">' +
            '<span>\u26a1 Rapid Assembly +$<span class="dsb__mobile-rapid-fee">0</span></span>' +
          '</label>' +
          '<button class="dsb__mobile-bar-save">Save Draft</button>' +
        '</div>' +
        '<div class="dsb__mobile-bar-main">' +
          '<button class="dsb__mobile-bar-np" title="Manage nameplates">' +
            '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="3" y="5" width="18" height="14" rx="2"/><line x1="7" y1="10" x2="17" y2="10"/><line x1="7" y1="14" x2="13" y2="14"/></svg>' +
            ' <span class="dsb__mobile-bar-np-count">Nameplates 0/12</span>' +
          '</button>' +
          '<button class="dsb__mobile-bar-text" title="Manage text blocks" style="display:none">' +
            '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M4 7V4h16v3"/><line x1="12" y1="4" x2="12" y2="20"/><line x1="8" y1="20" x2="16" y2="20"/></svg>' +
            ' <span class="dsb__mobile-bar-text-count">Add Text</span>' +
          '</button>' +
          '<button class="dsb__mobile-bar-addons">+ Add-ons</button>' +
          '<span class="dsb__mobile-bar-total">$169</span>' +
          '<button class="dsb__mobile-bar-atc">Add to Cart</button>' +
        '</div>';

      this.el.appendChild(bar);

      // Nameplate counter button — opens slide-up panel
      bar.querySelector('.dsb__mobile-bar-np').addEventListener('click', function () {
        self._openNpPanel();
      });

      // Text button — opens text slide-up panel (core mode)
      bar.querySelector('.dsb__mobile-bar-text').addEventListener('click', function () {
        self._openTextPanel();
      });

      // Add-ons button
      bar.querySelector('.dsb__mobile-bar-addons').addEventListener('click', function () {
        self._openAddonsPanel();
      });

      // Save draft button
      bar.querySelector('.dsb__mobile-bar-save').addEventListener('click', function () {
        self._saveDraft();
      });

      // ATC button
      bar.querySelector('.dsb__mobile-bar-atc').addEventListener('click', function () {
        self._addToCart(this);
      });

      // Rapid assembly checkbox
      var rapidCb = bar.querySelector('.dsb__mobile-rapid-cb');
      if (rapidCb) {
        rapidCb.addEventListener('change', function () {
          self._rapidAssembly = rapidCb.checked;
          // Sync desktop rapid checkbox
          var deskCb = self.el.querySelector('.dsb__rapid-cb');
          if (deskCb) deskCb.checked = self._rapidAssembly;
          self._updatePrice();
        });
      }

      this._mobileBar = bar;
    },

    _updateMobileBar: function () {
      if (!this._mobileBar) return;
      var total = this._calcTotal();
      var rapidFee = this._rapidAssembly ? Math.max(5, Math.round(total * 0.10)) : 0;
      this._mobileBar.querySelector('.dsb__mobile-bar-total').textContent = '$' + (total + rapidFee);

      // Update rapid fee display
      var feeEl = this._mobileBar.querySelector('.dsb__mobile-rapid-fee');
      if (feeEl) feeEl.textContent = Math.max(5, Math.round(total * 0.10));

      // Sync rapid checkbox state
      var rapidCb = this._mobileBar.querySelector('.dsb__mobile-rapid-cb');
      if (rapidCb) rapidCb.checked = this._rapidAssembly;

      var countEl = this._mobileBar.querySelector('.dsb__mobile-bar-np-count');
      var textBtn = this._mobileBar.querySelector('.dsb__mobile-bar-text');
      var npBtn = this._mobileBar.querySelector('.dsb__mobile-bar-np');

      // Update Step 3 canvas header counter (pro mode)
      var step3Count = this.el.querySelector('[data-step3-count]');
      var step3Header = this.el.querySelector('[data-step3-header]');
      if (step3Count) {
        step3Count.textContent = '(' + this.pro.nameplates.length + '/12 created)';
      }
      if (step3Header) {
        step3Header.style.display = this.mode === 'pro' ? '' : 'none';
      }

      // Step 4 canvas header visibility (core mode) — no counter shown
      var step4Header = this.el.querySelector('[data-core-step4-header]');
      if (step4Header) {
        step4Header.style.display = this.mode === 'core' ? '' : 'none';
      }

      if (this.mode === 'pro') {
        var npCount = this.pro.nameplates.length;
        countEl.textContent = 'Nameplates ' + npCount + '/12';
        // Only show NP button once they have at least 1 nameplate
        npBtn.style.display = npCount > 0 ? '' : 'none';
        if (textBtn) textBtn.style.display = 'none';
      } else if (this.mode === 'nameplates') {
        countEl.textContent = 'Nameplates ' + this.nm.items.length;
        this._mobileBar.querySelector('.dsb__mobile-bar-np').style.display = '';
        if (textBtn) textBtn.style.display = 'none';
      } else if (this.mode === 'core') {
        this._mobileBar.querySelector('.dsb__mobile-bar-np').style.display = 'none';
        if (textBtn) {
          // Only show Text button once at least one block exists (mirror pro nameplate gating)
          textBtn.style.display = this.core.textBlocks.length > 0 ? '' : 'none';
          var tc = this._mobileBar.querySelector('.dsb__mobile-bar-text-count');
          if (tc) tc.textContent = 'Add Text';
        }
      } else {
        this._mobileBar.querySelector('.dsb__mobile-bar-np').style.display = 'none';
        if (textBtn) textBtn.style.display = 'none';
      }
    },

    _openNpPanel: function () {
      var self = this;
      var existing = this.el.querySelector('.dsb__np-slideup');
      if (existing) { this._closeNpPanel(); return; }

      var overlay = document.createElement('div');
      overlay.className = 'dsb__np-slideup-overlay';

      var panel = document.createElement('div');
      panel.className = 'dsb__np-slideup';

      var countLabel = this.mode === 'pro'
        ? this.pro.nameplates.length + ' of 12 included free'
        : this.nm.items.length + ' nameplates';

      panel.innerHTML =
        '<div class="dsb__np-slideup-header">' +
          '<span>Your Nameplates (' + countLabel + ')</span>' +
          '<button class="dsb__np-slideup-close">\u00d7</button>' +
        '</div>' +
        '<div class="dsb__np-slideup-list"></div>' +
        '<button class="dsb__np-slideup-add">+ Add Nameplate</button>';

      this.el.appendChild(overlay);
      this.el.appendChild(panel);

      this._renderNpPanelList(panel);
      this._updateNpPanelHeader(panel);
      this._updateNpAddBtn(panel);

      // Add button — add a new nameplate and open inline edit
      panel.querySelector('.dsb__np-slideup-add').addEventListener('click', function () {
        var newNp;
        if (self.mode === 'pro') {
          self._addProNameplate();
          newNp = self.pro.nameplates[self.pro.nameplates.length - 1];
        } else {
          self._addNmItem();
          newNp = self.nm.items[self.nm.items.length - 1];
        }
        // Re-render the list and open edit for the new plate
        self._renderNpPanelList(panel);
        self._updateNpPanelHeader(panel);
        self._updateNpAddBtn(panel);
        self._updateMobileBar();
        self._updatePrice();
        if (newNp) self._openInlineEdit(panel, newNp);
      });

      // Close
      panel.querySelector('.dsb__np-slideup-close').addEventListener('click', function () { self._closeNpPanel(); });
      overlay.addEventListener('click', function () { self._closeNpPanel(); });

      // Lock body scroll so canvas stays visible above slideup on mobile
      if (this._isMobile()) {
        document.body.style.overflow = 'hidden';
      }

      requestAnimationFrame(function () { panel.classList.add('dsb__np-slideup--open'); overlay.classList.add('dsb__np-slideup-overlay--open'); });
    },

    _renderNpPanelList: function (panel) {
      var self = this;
      var list = panel.querySelector('.dsb__np-slideup-list');
      list.innerHTML = '';
      var items = this.mode === 'pro' ? this.pro.nameplates : this.nm.items;

      items.forEach(function (np) {
        var npColor = NP_COLORS.filter(function (c) { return c.id === (np.npColorId || self.pro.npColorId); })[0];
        var colorDot = npColor ? npColor.hex : '#1a1a1a';

        var row = document.createElement('div');
        row.className = 'dsb__np-slideup-item';
        row.setAttribute('data-slideup-np', np.id);
        row.innerHTML =
          '<span class="dsb__np-slideup-dot" style="background:' + colorDot + '"></span>' +
          '<span class="dsb__np-slideup-text">' + self._esc(np.text || 'Untitled') + '</span>' +
          '<span class="dsb__np-slideup-size">' + (np.size || 'medium').charAt(0).toUpperCase() + '</span>' +
          (np.nfc ? '<span class="dsb__np-slideup-nfc">NFC</span>' : '') +
          '<button class="dsb__np-slideup-edit" title="Edit">\u270e</button>' +
          '<button class="dsb__np-slideup-del" title="Delete">\u00d7</button>';
        list.appendChild(row);

        // Edit — open inline edit form within the panel
        row.querySelector('.dsb__np-slideup-edit').addEventListener('click', function () {
          self._openInlineEdit(panel, np);
        });

        // Also tap the row text to edit
        row.querySelector('.dsb__np-slideup-text').addEventListener('click', function () {
          self._openInlineEdit(panel, np);
        });

        // Delete
        row.querySelector('.dsb__np-slideup-del').addEventListener('click', function () {
          if (self.mode === 'pro') {
            self.pro.nameplates = self.pro.nameplates.filter(function (n) { return n.id !== np.id; });
            if (self.pro.selected === np.id) self.pro.selected = null;
            self._updateNpCounter();
            self._renderProNpList();
          } else {
            self.nm.items = self.nm.items.filter(function (n) { return n.id !== np.id; });
            if (self.nm.selected === np.id) self.nm.selected = null;
          }
          row.remove();
          self._updatePrice();
          self.render();
          self._updateNpPanelHeader(panel);
          self._updateNpAddBtn(panel);
          self._updateMobileBar();
          self._updateProNameplateAccess();
        });
      });
    },

    _updateNpPanelHeader: function (panel) {
      var hdr = panel.querySelector('.dsb__np-slideup-header span');
      if (!hdr) return;
      var items = this.mode === 'pro' ? this.pro.nameplates : this.nm.items;
      if (this.mode === 'pro') {
        var count = items.length;
        if (count <= NP_FREE_LIMIT) {
          hdr.textContent = 'Your Nameplates (' + count + ' of ' + NP_FREE_LIMIT + ' included free)';
        } else {
          var extra = count - NP_FREE_LIMIT;
          var extraCost = 0;
          items.slice(NP_FREE_LIMIT).forEach(function (np) { extraCost += NP_EXTRA_PRICES[np.size] || NP_EXTRA_PRICES.medium; });
          hdr.textContent = 'Your Nameplates (' + NP_FREE_LIMIT + ' free + ' + extra + ' extra · +$' + extraCost + ')';
        }
      } else {
        hdr.textContent = 'Your Nameplates (' + items.length + ' nameplates)';
      }
    },

    _updateNpAddBtn: function (panel) {
      var btn = panel.querySelector('.dsb__np-slideup-add');
      if (!btn) return;
      if (this.mode === 'pro' && this.pro.nameplates.length >= NP_FREE_LIMIT) {
        btn.textContent = '+ Add Nameplate (extra charges apply)';
      } else {
        btn.textContent = '+ Add Nameplate';
      }
    },

    _openInlineEdit: function (panel, np) {
      var self = this;
      // Remove any existing edit form
      var existing = panel.querySelector('.dsb__np-inline-edit');
      if (existing) existing.remove();

      var form = document.createElement('div');
      form.className = 'dsb__np-inline-edit';

      var sizes = ['small', 'medium', 'large'];
      var sizeBtns = sizes.map(function (s) {
        return '<button class="dsb__np-ie-size' + (np.size === s ? ' active' : '') + '" data-ie-size="' + s + '">' +
          s.charAt(0).toUpperCase() + '</button>';
      }).join('');

      var colorSwatches = NP_COLORS.map(function (c) {
        var isActive = (np.npColorId || self.pro.npColorId) === c.id;
        return '<button class="dsb__np-ie-color' + (isActive ? ' active' : '') + '" data-ie-color="' + c.id + '" style="background:' + c.hex + '" title="' + c.name + '"></button>';
      }).join('');

      // Font dropdown options
      var fontOpts = FONTS.map(function (f) {
        return '<option value="' + f.id + '"' + (np.font === f.id ? ' selected' : '') + '>' + f.name + '</option>';
      }).join('');

      // Text color swatches
      var textColorSwatches = TEXT_COLORS.map(function (c) {
        return '<button class="dsb__np-ie-tcolor' + (np.colorId === c.id ? ' active' : '') + '" data-ie-tcolor="' + c.id + '" style="background:' + c.hex + '" title="' + c.name + '"></button>';
      }).join('');

      // Corner style options (for Pro nameplates)
      var cornerBtns = ['rounded', 'standard'].map(function (c) {
        return '<button class="dsb__np-ie-corner' + ((np.corner || 'rounded') === c ? ' active' : '') + '" data-ie-corner="' + c + '">' + c.charAt(0).toUpperCase() + c.slice(1) + '</button>';
      }).join('');

      form.innerHTML =
        '<div class="dsb__np-ie-row">' +
          '<label class="dsb__np-ie-label">Text</label>' +
          '<input class="dsb__np-ie-input" type="text" value="' + self._esc(np.text) + '" maxlength="40" placeholder="Nameplate text">' +
          '<span class="dsb__np-ie-count">' + (np.text || '').length + '/40</span>' +
        '</div>' +
        '<div class="dsb__np-ie-row-inline">' +
          '<div class="dsb__np-ie-half">' +
            '<label class="dsb__np-ie-label">Size</label>' +
            '<div class="dsb__np-ie-sizes">' + sizeBtns + '</div>' +
          '</div>' +
          '<div class="dsb__np-ie-half">' +
            '<label class="dsb__np-ie-label">Corner</label>' +
            '<div class="dsb__np-ie-corners">' + cornerBtns + '</div>' +
          '</div>' +
        '</div>' +
        '<div class="dsb__np-ie-row">' +
          '<label class="dsb__np-ie-label">Plate Color</label>' +
          '<div class="dsb__np-ie-colors">' + colorSwatches + '</div>' +
        '</div>' +
        '<div class="dsb__np-ie-row dsb__np-ie-nfc-row">' +
          '<label class="dsb__np-ie-label">NFC Chip <span style="color:#c8a96e;font-weight:400;">+$25</span></label>' +
          '<button class="dsb__np-ie-nfc-toggle' + (np.nfc ? ' active' : '') + '">' + (np.nfc ? 'ON' : 'OFF') + '</button>' +
          '<span class="dsb__np-ie-nfc-hint">Customers tap their phone to open any URL</span>' +
        '</div>' +
        '<div class="dsb__np-ie-nfc-url" style="display:' + (np.nfc ? 'block' : 'none') + '">' +
          '<input class="dsb__np-ie-nfc-input" type="url" placeholder="https://your-link.com" value="' + self._esc(np.nfcUrl || '') + '">' +
        '</div>' +
        '<div class="dsb__np-ie-row-inline">' +
          '<div class="dsb__np-ie-half">' +
            '<label class="dsb__np-ie-label">Font</label>' +
            '<select class="dsb__np-ie-font">' + fontOpts + '</select>' +
          '</div>' +
          '<div class="dsb__np-ie-half">' +
            '<label class="dsb__np-ie-label">Text Color</label>' +
            '<div class="dsb__np-ie-tcolors">' + textColorSwatches + '</div>' +
          '</div>' +
        '</div>' +
        '<div class="dsb__np-ie-row-inline">' +
          '<div class="dsb__np-ie-half">' +
            '<label class="dsb__np-ie-label">Style</label>' +
            '<div class="dsb__np-ie-styles">' +
              '<button class="dsb__np-ie-style' + (np.bold ? ' active' : '') + '" data-ie-style="bold"><strong>B</strong></button>' +
              '<button class="dsb__np-ie-style' + (np.italic ? ' active' : '') + '" data-ie-style="italic"><em>I</em></button>' +
            '</div>' +
          '</div>' +
          '<div class="dsb__np-ie-half">' +
            '<label class="dsb__np-ie-label">Text Size</label>' +
            '<input type="range" class="dsb__np-ie-tsize" min="10" max="28" value="' + (np.textSize || 16) + '">' +
          '</div>' +
        '</div>' +
        '<div class="dsb__np-ie-actions">' +
          '<button class="dsb__np-ie-duplicate">Duplicate</button>' +
          '<button class="dsb__np-ie-done">Done</button>' +
        '</div>';

      // Insert right after the row for this nameplate
      var npRow = panel.querySelector('[data-slideup-np="' + np.id + '"]');
      if (npRow && npRow.nextSibling) {
        npRow.parentNode.insertBefore(form, npRow.nextSibling);
      } else {
        panel.querySelector('.dsb__np-slideup-list').appendChild(form);
      }
      npRow.style.display = 'none'; // Hide the summary row while editing

      // Scroll the edit form to the top of the slideup so it's fully visible
      requestAnimationFrame(function () {
        form.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });

      // Do NOT auto-focus — let user tap the input when they want to type
      var input = form.querySelector('.dsb__np-ie-input');

      // When mobile keyboard closes, scroll canvas back into view
      if (this._isMobile()) {
        var scrollCanvasBack = function () {
          setTimeout(function () {
            var canvasArea = self.el.querySelector('.dsb__canvas-area');
            if (canvasArea) {
              canvasArea.scrollIntoView({ behavior: 'smooth', block: 'start' });
            }
          }, 300);
        };
        input.addEventListener('blur', scrollCanvasBack);
      }

      // Text input — live update
      input.addEventListener('input', function () {
        np.text = input.value;
        form.querySelector('.dsb__np-ie-count').textContent = input.value.length + '/40';
        self.render();
      });

      // Size buttons
      form.querySelectorAll('[data-ie-size]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          np.size = btn.dataset.ieSize;
          form.querySelectorAll('[data-ie-size]').forEach(function (b) { b.classList.toggle('active', b === btn); });
          self.render();
          self._updatePrice();
        });
      });

      // Corner buttons
      form.querySelectorAll('[data-ie-corner]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          np.corner = btn.dataset.ieCorner;
          form.querySelectorAll('[data-ie-corner]').forEach(function (b) { b.classList.toggle('active', b === btn); });
          self.render();
        });
      });

      // Plate color swatches
      form.querySelectorAll('[data-ie-color]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          np.npColorId = btn.dataset.ieColor;
          form.querySelectorAll('[data-ie-color]').forEach(function (b) { b.classList.toggle('active', b === btn); });
          self.render();
        });
      });

      // Font dropdown
      var fontSel = form.querySelector('.dsb__np-ie-font');
      if (fontSel) {
        fontSel.addEventListener('change', function () {
          np.font = fontSel.value;
          self.render();
        });
      }

      // Text color swatches
      form.querySelectorAll('[data-ie-tcolor]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          np.colorId = btn.dataset.ieTcolor;
          form.querySelectorAll('[data-ie-tcolor]').forEach(function (b) { b.classList.toggle('active', b === btn); });
          self.render();
        });
      });

      // Bold/Italic toggles
      form.querySelectorAll('[data-ie-style]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var prop = btn.dataset.ieStyle;
          np[prop] = !np[prop];
          btn.classList.toggle('active', np[prop]);
          self.render();
        });
      });

      // Text size slider
      var tsizeRange = form.querySelector('.dsb__np-ie-tsize');
      if (tsizeRange) {
        tsizeRange.addEventListener('input', function () {
          np.textSize = parseInt(tsizeRange.value);
          self.render();
        });
      }

      // NFC toggle
      var nfcBtn = form.querySelector('.dsb__np-ie-nfc-toggle');
      var nfcUrlWrap = form.querySelector('.dsb__np-ie-nfc-url');
      nfcBtn.addEventListener('click', function () {
        np.nfc = !np.nfc;
        nfcBtn.classList.toggle('active', np.nfc);
        nfcBtn.textContent = np.nfc ? 'ON' : 'OFF';
        if (nfcUrlWrap) nfcUrlWrap.style.display = np.nfc ? 'block' : 'none';
        self._updatePrice();
        self.render();
      });

      // NFC URL input
      var nfcUrlInput = form.querySelector('.dsb__np-ie-nfc-input');
      if (nfcUrlInput) {
        nfcUrlInput.addEventListener('input', function () {
          np.nfcUrl = nfcUrlInput.value;
        });
      }

      // Duplicate button
      form.querySelector('.dsb__np-ie-duplicate').addEventListener('click', function () {
        var clone = JSON.parse(JSON.stringify(np));
        clone.id = 'np_' + Date.now() + '_' + Math.random().toString(36).substr(2, 5);
        clone.text = np.text;
        if (self.mode === 'pro') {
          // Offset position slightly
          clone.x = (np.x || 320) + 15;
          clone.y = (np.y || 320) + 15;
          self.pro.nameplates.push(clone);
          self._updateNpCounter();
          self._renderProNpList();
        } else {
          self.nm.items.push(clone);
        }
        // Close current edit, re-render list, open edit for clone
        form.remove();
        npRow.style.display = '';
        self._renderNpPanelList(panel);
        self._updateNpPanelHeader(panel);
        self._updateMobileBar();
        self._updatePrice();
        self.render();
        self._openInlineEdit(panel, clone);
      });

      // Done button
      form.querySelector('.dsb__np-ie-done').addEventListener('click', function () {
        form.remove();
        npRow.style.display = '';
        // Update the row text
        npRow.querySelector('.dsb__np-slideup-text').textContent = np.text || 'Untitled';
        npRow.querySelector('.dsb__np-slideup-size').textContent = (np.size || 'medium').charAt(0).toUpperCase();
        var dotEl = npRow.querySelector('.dsb__np-slideup-dot');
        if (dotEl) {
          var nc = NP_COLORS.filter(function (c) { return c.id === np.npColorId; })[0];
          if (nc) dotEl.style.background = nc.hex;
        }
        // Update NFC badge
        var existingNfc = npRow.querySelector('.dsb__np-slideup-nfc');
        if (np.nfc && !existingNfc) {
          var badge = document.createElement('span');
          badge.className = 'dsb__np-slideup-nfc';
          badge.textContent = 'NFC';
          npRow.querySelector('.dsb__np-slideup-size').after(badge);
        } else if (!np.nfc && existingNfc) {
          existingNfc.remove();
        }
        // Re-render main list too
        if (self.mode === 'pro') self._renderProNpList();
        self.render();
        self._updatePrice();
      });
    },

    _closeNpPanel: function () {
      var self = this;
      var panel = this.el.querySelector('.dsb__np-slideup');
      var overlay = this.el.querySelector('.dsb__np-slideup-overlay');
      var wasOpen = !!panel;
      if (panel) panel.remove();
      if (overlay) overlay.remove();
      document.body.style.overflow = '';
      // Only scroll to canvas if a panel was actually open
      if (wasOpen) {
        setTimeout(function () {
          var canvasArea = self.el.querySelector('.dsb__canvas-area');
          if (canvasArea) canvasArea.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }, 100);
      }
    },

    // ── Text Slideup Panel (Core mobile) ──────────────────────────────────────

    _openTextPanel: function () {
      var self = this;
      var existing = this.el.querySelector('.dsb__text-slideup');
      if (existing) { this._closeTextPanel(); return; }

      var overlay = document.createElement('div');
      overlay.className = 'dsb__np-slideup-overlay';

      var panel = document.createElement('div');
      panel.className = 'dsb__text-slideup';

      panel.innerHTML =
        '<div class="dsb__text-slideup-header">' +
          '<span>Your Text Blocks</span>' +
          '<button class="dsb__text-slideup-close">\u00d7</button>' +
        '</div>' +
        '<div class="dsb__text-slideup-list"></div>' +
        '<button class="dsb__text-slideup-add">+ Add Text Block</button>';

      this.el.appendChild(overlay);
      this.el.appendChild(panel);

      this._renderTextPanelList(panel);

      // Add button
      panel.querySelector('.dsb__text-slideup-add').addEventListener('click', function () {
        self._addCoreText();
        self._renderTextPanelList(panel);
        self._updateTextPanelHeader(panel);
        self._updateMobileBar();
        self._updateCoreCta();
      });

      // Close
      panel.querySelector('.dsb__text-slideup-close').addEventListener('click', function () { self._closeTextPanel(); });
      overlay.addEventListener('click', function () { self._closeTextPanel(); });

      if (this._isMobile()) {
        document.body.style.overflow = 'hidden';
      }

      requestAnimationFrame(function () { panel.classList.add('dsb__text-slideup--open'); overlay.classList.add('dsb__np-slideup-overlay--open'); });
    },

    _closeTextPanel: function () {
      var self = this;
      var panel = this.el.querySelector('.dsb__text-slideup');
      var overlay = this.el.querySelector('.dsb__np-slideup-overlay');
      var wasOpen = !!panel;
      if (panel) panel.remove();
      if (overlay) overlay.remove();
      document.body.style.overflow = '';
      if (wasOpen) {
        setTimeout(function () {
          var canvasArea = self.el.querySelector('.dsb__canvas-area');
          if (canvasArea) canvasArea.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }, 100);
      }
    },

    _updateTextPanelHeader: function (panel) {
      var hdr = panel.querySelector('.dsb__text-slideup-header span');
      if (hdr) hdr.textContent = 'Your Text Blocks';
    },

    _renderTextPanelList: function (panel) {
      var self = this;
      var list = panel.querySelector('.dsb__text-slideup-list');
      if (!list) return;
      list.innerHTML = '';

      this.core.textBlocks.forEach(function (block) {
        var item = self._makeTextItem(block,
          function () { // onRemove
            self.core.textBlocks = self.core.textBlocks.filter(function (b) { return b.id !== block.id; });
            if (self.core.selected === block.id) self.core.selected = null;
            self._renderTextPanelList(panel);
            self._updateTextPanelHeader(panel);
            self._updateMobileBar();
            self._updateCoreCta();
            // Also sync desktop list
            self._renderCoreTextList();
            self.render();
          },
          function () { // onSelect
            self.core.selected = block.id;
            self._syncCoreSelection();
            self.render();
          },
          function () { // onDuplicate
            self._duplicateCoreText(block);
            self._renderTextPanelList(panel);
            self._updateTextPanelHeader(panel);
            self._updateMobileBar();
            self._updateCoreCta();
          }
        );
        item.classList.toggle('active', self.core.selected === block.id);
        list.appendChild(item);

        // Keyboard scroll fix for mobile inputs
        if (self._isMobile()) {
          var inputs = item.querySelectorAll('input[type="text"], input[type="url"]');
          inputs.forEach(function (inp) {
            inp.addEventListener('blur', function () {
              setTimeout(function () {
                var canvasArea = self.el.querySelector('.dsb__canvas-area');
                if (canvasArea) canvasArea.scrollIntoView({ behavior: 'smooth', block: 'start' });
              }, 300);
            });
          });
        }
      });
    },

    _openAddonsPanel: function () {
      var self = this;
      var existing = this.el.querySelector('.dsb__addons-slideup');
      if (existing) { existing.remove(); var ov = this.el.querySelector('.dsb__np-slideup-overlay'); if (ov) ov.remove(); document.body.style.overflow = ''; return; }

      var overlay = document.createElement('div');
      overlay.className = 'dsb__np-slideup-overlay';

      var panel = document.createElement('div');
      panel.className = 'dsb__np-slideup dsb__addons-slideup';

      var stateObj = this.mode === 'pro' ? this.pro : this.core;
      var addons = this.mode === 'pro'
        ? [
            { key: 'keychain', name: 'NFC Keychain', desc: 'Attach to keys or bag', price: 19 },
            { key: 'bizcard', name: 'NFC Business Card', desc: 'Tap-enabled premium card', price: 29 },
          ]
        : [
            { key: 'nfcEmbed', name: 'Embedded NFC Chip', desc: 'Tap-to-link, fully programmable', price: 25 },
            { key: 'keychain', name: 'NFC Keychain', desc: 'Attach to keys or bag', price: 19 },
            { key: 'bizcard', name: 'NFC Business Card', desc: 'Tap-enabled premium card', price: 29 },
          ];

      var activeAddons = stateObj.addons;

      panel.innerHTML =
        '<div class="dsb__np-slideup-header">' +
          '<span>Add-ons</span>' +
          '<button class="dsb__np-slideup-close">\u00d7</button>' +
        '</div>' +
        '<div class="dsb__addons-slideup-list">' +
        addons.map(function (a) {
          var html = '<div class="dsb__addons-slideup-item' + (activeAddons[a.key] ? ' active' : '') + '" data-addon-key="' + a.key + '">' +
            '<div><strong>' + a.name + '</strong><br><span style="font-size:12px;color:#999;">' + a.desc + '</span></div>' +
            '<span class="dsb__addons-slideup-price">+$' + a.price + '</span>' +
          '</div>';
          // Sub-fields for keychain type
          if (a.key === 'keychain') {
            html += '<div class="dsb__addons-slideup-sub" data-slideup-sub="keychain" style="' + (activeAddons.keychain ? '' : 'display:none') + '">' +
              '<select class="dsb__addon-sub-select" data-slideup-keychain-type>' +
                '<option value="single"' + (stateObj.keychainType === 'single' ? ' selected' : '') + '>Single Keychain \u2014 $19</option>' +
                '<option value="3pack"' + (stateObj.keychainType === '3pack' ? ' selected' : '') + '>3-Pack \u2014 $49</option>' +
              '</select>' +
            '</div>';
          }
          // Sub-fields for bizcard text
          if (a.key === 'bizcard') {
            html += '<div class="dsb__addons-slideup-sub" data-slideup-sub="bizcard" style="' + (activeAddons.bizcard ? '' : 'display:none') + '">' +
              '<input class="dsb__addon-sub-input" type="text" value="' + self._esc(stateObj.bizcardText || '') + '" placeholder="Text for your card" maxlength="100" data-slideup-bizcard-text>' +
            '</div>';
          }
          return html;
        }).join('') +
        '</div>';

      this.el.appendChild(overlay);
      this.el.appendChild(panel);

      // Toggle addons
      panel.querySelectorAll('[data-addon-key]').forEach(function (row) {
        row.addEventListener('click', function () {
          var key = row.dataset.addonKey;
          activeAddons[key] = !activeAddons[key];
          row.classList.toggle('active', activeAddons[key]);
          // Sync with main sidebar toggles
          var mainRow = self.el.querySelector('[data-addon="' + key + '"]');
          if (mainRow) mainRow.classList.toggle('active', activeAddons[key]);
          // Show/hide sub-fields
          var sub = panel.querySelector('[data-slideup-sub="' + key + '"]');
          if (sub) sub.style.display = activeAddons[key] ? '' : 'none';
          var mainSub = self.el.querySelector('[data-addon-sub="' + key + '"]');
          if (mainSub) mainSub.style.display = activeAddons[key] ? '' : 'none';
          self._updatePrice();
        });
      });

      // Keychain type select
      var kcSel = panel.querySelector('[data-slideup-keychain-type]');
      if (kcSel) {
        kcSel.addEventListener('change', function () {
          stateObj.keychainType = kcSel.value;
          // Sync main sidebar
          var mainSel = self.el.querySelector('[data-keychain-type]');
          if (mainSel) mainSel.value = kcSel.value;
          self._updatePrice();
        });
      }

      // Bizcard text
      var bcInput = panel.querySelector('[data-slideup-bizcard-text]');
      if (bcInput) {
        bcInput.addEventListener('input', function () {
          stateObj.bizcardText = bcInput.value;
          var mainInput = self.el.querySelector('[data-bizcard-text]');
          if (mainInput) mainInput.value = bcInput.value;
        });
      }

      panel.querySelector('.dsb__np-slideup-close').addEventListener('click', function () {
        panel.remove(); overlay.remove(); document.body.style.overflow = '';
      });
      overlay.addEventListener('click', function () {
        panel.remove(); overlay.remove(); document.body.style.overflow = '';
      });

      if (this._isMobile()) document.body.style.overflow = 'hidden';

      requestAnimationFrame(function () { panel.classList.add('dsb__np-slideup--open'); overlay.classList.add('dsb__np-slideup-overlay--open'); });
    },

    // ── Canvas CTA (mobile step 3 nudge) ──────────────────────────────────────

    _bindCanvasCta: function () {
      var self = this;
      var cta = this.el.querySelector('[data-canvas-cta]');
      if (!cta) return;
      var btn = cta.querySelector('[data-canvas-cta-btn]');
      if (btn) {
        btn.addEventListener('click', function () {
          // Directly add a nameplate and open the editor
          self._addProNameplate();
          self.render();
          self._updatePrice();
          self._updateMobileBar();
          self._updateCanvasCta();
          self._updateProNameplateAccess();
          // Open the editor for the new plate
          if (self._isMobile()) {
            var newNp = self.pro.nameplates[0];
            if (newNp) {
              self._openNpPanel();
              setTimeout(function () {
                var panel = self.el.querySelector('.dsb__np-slideup');
                if (panel && newNp) self._openInlineEdit(panel, newNp);
              }, 350);
            }
          }
        });
      }
    },

    _updateCanvasCta: function () {
      // Pro canvas CTA is now handled by _updateProNameplateAccess
      // Just handle the core CTA here
      this._updateCoreCta();
      this._updateProNameplateAccess();
    },

    _updateCoreCta: function () {
      var cta = this.el.querySelector('[data-canvas-cta-core]');
      if (!cta) return;
      if (this.mode !== 'core') { cta.style.display = 'none'; return; }
      var hasText = this.core.textBlocks.length > 0;
      cta.style.display = hasText ? 'none' : '';
    },

    _bindCoreCta: function () {
      var self = this;
      var btn = this.el.querySelector('[data-canvas-cta-core-btn]');
      if (btn) {
        btn.addEventListener('click', function () {
          self._openTextPanel();
        });
      }
    },

    // ── Core Style Preview Image ──────────────────────────────────────────────

    _updateCoreStylePreview: function () {
      var img = this.el.querySelector('[data-core-preview-img]');
      if (!img) return;
      var base = (this.el.dataset.assetBase || '/assets/') + 'core-';
      img.src = base + (this.core.corner || 'standard') + '.svg';
      img.alt = (this.core.corner || 'Standard') + ' display';
    },

    // ── Progressive Step Activation (mobile) ─────────────────────────────────

    _updateStepProgress: function () {
      var panel = this.el.querySelector('[data-panel="pro-sidebar"]');
      if (!panel) return;

      var step1 = panel.querySelector('[data-step="1"]');
      var step2 = panel.querySelector('[data-step="2"]');

      if (this._proStep1Done) {
        // Mark step 1 done, unlock step 2
        if (step1) {
          step1.classList.add('dsb__step--done');
          var num1 = step1.querySelector('.dsb__step-num');
          if (num1 && !num1.dataset.done) { num1.textContent = '\u2713'; num1.dataset.done = '1'; }
        }
        if (step2) {
          step2.classList.remove('dsb__step--locked');
          step2.style.transition = 'opacity 0.4s ease';
        }
      } else {
        // Ensure step 2 stays locked
        if (step2 && !step2.classList.contains('dsb__step--locked')) {
          step2.classList.add('dsb__step--locked');
        }
      }

      // Mark step 2 done when user interacts with colors
      if (this._proStep2Done && step2) {
        step2.classList.add('dsb__step--done');
        var num2 = step2.querySelector('.dsb__step-num');
        if (num2 && !num2.dataset.done) { num2.textContent = '\u2713'; num2.dataset.done = '1'; }
      }

      // ── CORE step progression (mirrors pro pattern) ──
      var corePanel = this.el.querySelector('[data-panel="core-sidebar"]');
      if (corePanel) {
        var cStep1 = corePanel.querySelector('[data-core-step="1"]') || corePanel.querySelector('[data-step="1"]');
        var cStep2 = corePanel.querySelector('[data-core-step="2"]');
        var cStep3 = corePanel.querySelector('[data-core-step="3"]');

        // Step 1 → done when corner chosen (auto)
        if (this._coreStep1Done && cStep1) {
          cStep1.classList.add('dsb__step--done');
          var cn1 = cStep1.querySelector('.dsb__step-num');
          if (cn1 && !cn1.dataset.done) { cn1.textContent = '\u2713'; cn1.dataset.done = '1'; }
        }
        // Step 2 unlocks once step 1 done
        if (cStep2) {
          if (this._coreStep1Done) { cStep2.classList.remove('dsb__step--locked'); }
          else if (!cStep2.classList.contains('dsb__step--locked')) { cStep2.classList.add('dsb__step--locked'); }
        }
        if (this._coreStep2Done && cStep2) {
          cStep2.classList.add('dsb__step--done');
          var cn2 = cStep2.querySelector('.dsb__step-num');
          if (cn2 && !cn2.dataset.done) { cn2.textContent = '\u2713'; cn2.dataset.done = '1'; }
        }
        // Step 3 unlocks once step 2 done
        if (cStep3) {
          if (this._coreStep2Done) { cStep3.classList.remove('dsb__step--locked'); }
          else if (!cStep3.classList.contains('dsb__step--locked')) { cStep3.classList.add('dsb__step--locked'); }
        }
        if (this._coreStep3Done && cStep3) {
          cStep3.classList.add('dsb__step--done');
          var cn3 = cStep3.querySelector('.dsb__step-num');
          if (cn3 && !cn3.dataset.done) { cn3.textContent = '\u2713'; cn3.dataset.done = '1'; }
        }
      }

      // Gate canvas area on mode-specific completion
      var canvasArea = this.el.querySelector('.dsb__canvas-area');
      if (canvasArea) {
        var shouldLock = false;
        if (this.mode === 'pro') shouldLock = !(this._proStep1Done && this._proStep2Done);
        else if (this.mode === 'core') shouldLock = !(this._coreStep1Done && this._coreStep2Done && this._coreStep3Done);
        canvasArea.classList.toggle('dsb__canvas-area--locked', shouldLock);
      }

      this._updateProNameplateAccess();
      this._updateCoreTextAccess();
    },

    _updateProNameplateAccess: function () {
      // Show sticky "add first nameplate" bar once both steps are done
      var canAdd = this._proStep1Done && this._proStep2Done;
      var cta = this.el.querySelector('[data-canvas-cta]');
      var firstNpBar = this.el.querySelector('.dsb__first-np-bar');

      if (this.mode !== 'pro') {
        if (firstNpBar) firstNpBar.style.display = 'none';
        return;
      }

      var hasNp = this.pro.nameplates.length > 0;

      // Canvas CTA: hide it (we use the sticky bar instead)
      if (cta) cta.style.display = 'none';

      // Sticky "ADD YOUR FIRST NAMEPLATE" bar
      if (canAdd && !hasNp) {
        if (!firstNpBar) this._buildFirstNpBar();
        firstNpBar = this.el.querySelector('.dsb__first-np-bar');
        if (firstNpBar) firstNpBar.style.display = '';
      } else if (firstNpBar) {
        firstNpBar.style.display = 'none';
      }
    },

    _buildFirstNpBar: function () {
      var self = this;
      var bar = document.createElement('div');
      bar.className = 'dsb__first-np-bar';
      bar.innerHTML =
        '<button class="dsb__first-np-bar-btn">' +
          '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>' +
          'ADD YOUR FIRST NAMEPLATE' +
        '</button>';
      this.el.appendChild(bar);

      bar.querySelector('.dsb__first-np-bar-btn').addEventListener('click', function () {
        self._addProNameplate();
        self.render();
        self._updatePrice();
        self._updateMobileBar();
        // Hide this bar since we now have a nameplate
        bar.style.display = 'none';
        // Open the inline editor on mobile
        if (self._isMobile()) {
          var newNp = self.pro.nameplates[0];
          if (newNp) {
            self._openNpPanel();
            // Small delay so the panel is open before we try to edit
            setTimeout(function () {
              var panel = self.el.querySelector('.dsb__np-slideup');
              if (panel && newNp) self._openInlineEdit(panel, newNp);
            }, 350);
          }
        }
      });
    },

    _updateCoreTextAccess: function () {
      // Show sticky "add first text block" bar once all three core steps are done
      var firstTextBar = this.el.querySelector('.dsb__first-text-bar');

      if (this.mode !== 'core') {
        if (firstTextBar) firstTextBar.style.display = 'none';
        return;
      }

      var canAdd = this._coreStep1Done && this._coreStep2Done && this._coreStep3Done;
      var hasText = this.core.textBlocks.length > 0;

      if (canAdd && !hasText) {
        if (!firstTextBar) this._buildFirstTextBar();
        firstTextBar = this.el.querySelector('.dsb__first-text-bar');
        if (firstTextBar) firstTextBar.style.display = '';
      } else if (firstTextBar) {
        firstTextBar.style.display = 'none';
      }
    },

    _buildFirstTextBar: function () {
      var self = this;
      var bar = document.createElement('div');
      bar.className = 'dsb__first-np-bar dsb__first-text-bar';
      bar.innerHTML =
        '<button class="dsb__first-np-bar-btn">' +
          '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>' +
          'ADD YOUR FIRST TEXT BLOCK' +
        '</button>';
      this.el.appendChild(bar);

      bar.querySelector('.dsb__first-np-bar-btn').addEventListener('click', function () {
        self._addCoreText();
        self.render();
        self._updatePrice();
        self._updateMobileBar();
        bar.style.display = 'none';
        // Open the inline editor on mobile
        if (self._isMobile()) {
          var newBlk = self.core.textBlocks[0];
          if (newBlk) {
            // Find the text item in the list and open its inline editor
            setTimeout(function () {
              var item = self.el.querySelector('.dsb__text-item[data-id="' + newBlk.id + '"]');
              if (item) {
                var editBtn = item.querySelector('[data-edit-text]') || item.querySelector('.dsb__text-edit-btn');
                if (editBtn) editBtn.click();
                else item.click();
              }
            }, 200);
          }
        }
      });
    },

    // ── Pre-Checkout Reassurance Modal ───────────────────────────────────────

    _buildReassuranceModal: function () {
      var modal = document.createElement('div');
      modal.className = 'dsb__reassure dsb__reassure--hidden';
      modal.innerHTML =
        '<div class="dsb__reassure-box">' +
          '<div class="dsb__reassure-icon">\u2705</div>' +
          '<p class="dsb__reassure-msg">Before we build \u2014 you\u2019ll receive a design proof by email. Nothing is manufactured until you approve it.</p>' +
          '<div class="dsb__reassure-btns">' +
            '<button class="dsb__reassure-cart">View Cart & Checkout</button>' +
            '<button class="dsb__reassure-back">Keep Building</button>' +
          '</div>' +
        '</div>';
      this.el.appendChild(modal);

      modal.querySelector('.dsb__reassure-back').addEventListener('click', function () {
        modal.classList.add('dsb__reassure--hidden');
      });
      modal.querySelector('.dsb__reassure-cart').addEventListener('click', function () {
        window.location.href = '/cart';
      });

      this._reassureModal = modal;
    },

    // ── Draft Save / Load ────────────────────────────────────────────────────

    _DRAFT_KEY: 'ssmade_builder_draft',

    _bindDraft: function () {
      var self = this;
      var btn = this.el.querySelector('[data-save-draft]');
      if (!btn) return;
      btn.addEventListener('click', function () { self._saveDraft(); });
    },

    _saveDraft: function () {
      var draft = {
        mode: this.mode,
        core: JSON.parse(JSON.stringify(this.core)),
        pro:  JSON.parse(JSON.stringify(this.pro)),
        nm:   JSON.parse(JSON.stringify(this.nm)),
        rapidAssembly: this._rapidAssembly,
        savedAt: new Date().toISOString(),
      };
      try {
        localStorage.setItem(this._DRAFT_KEY, JSON.stringify(draft));
        this._showDraftToast('Draft saved!');
      } catch (e) {
        this._showDraftToast('Could not save draft.');
      }
    },

    _loadDraft: function () {
      try {
        var raw = localStorage.getItem(this._DRAFT_KEY);
        if (!raw) return null;
        return JSON.parse(raw);
      } catch (e) { return null; }
    },

    _applyDraft: function (draft) {
      if (!draft) return;
      if (draft.core) {
        Object.keys(draft.core).forEach(function (k) { this.core[k] = draft.core[k]; }.bind(this));
      }
      if (draft.pro) {
        Object.keys(draft.pro).forEach(function (k) { this.pro[k] = draft.pro[k]; }.bind(this));
      }
      if (draft.nm) {
        Object.keys(draft.nm).forEach(function (k) { this.nm[k] = draft.nm[k]; }.bind(this));
      }
      if (draft.rapidAssembly !== undefined) this._rapidAssembly = draft.rapidAssembly;
      if (draft.mode) this._switchMode(draft.mode);

      // Drafts have already been through the steps
      this._proStep1Done = true;
      this._proStep2Done = true;
      this._coreStep1Done = true;
      this._coreStep2Done = true;
      this._coreStep3Done = true;

      // Sync UI state: active toggles, color swatches, etc.
      this._syncUiFromState();
      this.render();
      this._updatePrice();
      this._updateStepProgress();
    },

    _syncUiFromState: function () {
      var p;
      // Core sidebar
      p = this.el.querySelector('[data-panel="core-sidebar"]');
      if (p) {
        p.querySelectorAll('[data-size]').forEach(function (b) { b.classList.toggle('active', b.dataset.size === this.core.size); }.bind(this));
        p.querySelectorAll('[data-corner]').forEach(function (b) { b.classList.toggle('active', b.dataset.corner === this.core.corner); }.bind(this));
        p.querySelectorAll('[data-bg-color]').forEach(function (b) { b.classList.toggle('active', b.dataset.bgColor === this.core.bgColorId); }.bind(this));
        var self = this;
        ['nfcEmbed', 'keychain', 'bizcard'].forEach(function (k) {
          var row = p.querySelector('[data-addon="' + k + '"]');
          if (row) row.classList.toggle('active', !!self.core.addons[k]);
          var sub = p.querySelector('[data-addon-sub="' + k + '"]');
          if (sub) sub.style.display = self.core.addons[k] ? 'block' : 'none';
        });
      }
      // Pro sidebar
      p = this.el.querySelector('[data-panel="pro-sidebar"]');
      if (p) {
        p.querySelectorAll('[data-variant]').forEach(function (b) { b.classList.toggle('active', b.dataset.variant === this.pro.variant); }.bind(this));
        p.querySelectorAll('[data-orient]').forEach(function (b) { b.classList.toggle('active', b.dataset.orient === this.pro.orientation); }.bind(this));
        p.querySelectorAll('[data-board-color]').forEach(function (b) { b.classList.toggle('active', b.dataset.boardColor === this.pro.boardColorId); }.bind(this));
        p.querySelectorAll('[data-frame-color]').forEach(function (b) { b.classList.toggle('active', b.dataset.frameColor === this.pro.frameColorId); }.bind(this));
        this._updateFrameSwatches(p);
        p.querySelectorAll('[data-np-color]').forEach(function (b) { b.classList.toggle('active', b.dataset.npColor === this.pro.npColorId); }.bind(this));
        p.querySelectorAll('[data-variant-preview-img]').forEach(function (img) {
          img.style.display = img.dataset.variantPreviewImg === this.pro.variant ? '' : 'none';
        }.bind(this));
        var self2 = this;
        ['keychain', 'bizcard'].forEach(function (k) {
          var row = p.querySelector('[data-addon="' + k + '"]');
          if (row) row.classList.toggle('active', !!self2.pro.addons[k]);
          var sub = p.querySelector('[data-addon-sub="' + k + '"]');
          if (sub) sub.style.display = self2.pro.addons[k] ? 'block' : 'none';
        });
      }
    },

    _checkDraftResume: function () {
      var self = this;
      var draft = this._loadDraft();
      if (!draft) return;
      var isUnified = this.el.dataset.unified === 'true';
      var params = new URLSearchParams(window.location.search);
      // Don't prompt if URL already has params (user clicked a specific link)
      if (params.get('product') || params.get('template') || params.get('niche')) return;
      if (!isUnified) return;

      // Show resume banner in wizard
      var wizard = document.querySelector('[data-build-wizard]');
      if (!wizard) return;
      var saved = new Date(draft.savedAt);
      var ago = this._timeAgo(saved);
      var banner = document.createElement('div');
      banner.className = 'dsb__draft-banner';
      banner.innerHTML =
        '<p class="dsb__draft-banner-msg">You have an unsaved draft from ' + ago + '</p>' +
        '<div class="dsb__draft-banner-btns">' +
          '<button class="dsb__draft-banner-resume">Resume Draft</button>' +
          '<button class="dsb__draft-banner-discard">Start Fresh</button>' +
        '</div>';
      wizard.insertBefore(banner, wizard.firstChild);

      banner.querySelector('.dsb__draft-banner-resume').addEventListener('click', function () {
        banner.remove();
        self._showBuilder();
        self._applyDraft(draft);
      });
      banner.querySelector('.dsb__draft-banner-discard').addEventListener('click', function () {
        banner.remove();
        try { localStorage.removeItem(self._DRAFT_KEY); } catch (e) {}
      });
    },

    _showDraftToast: function (msg) {
      var toast = this.el.querySelector('[data-draft-toast]');
      if (!toast) return;
      var msgEl = toast.querySelector('[data-draft-toast-msg]');
      if (msgEl) msgEl.textContent = msg;
      toast.classList.remove('dsb__draft-toast--hidden');
      clearTimeout(this._draftToastTimer);
      this._draftToastTimer = setTimeout(function () {
        toast.classList.add('dsb__draft-toast--hidden');
      }, 2500);
    },

    _timeAgo: function (date) {
      var s = Math.floor((Date.now() - date.getTime()) / 1000);
      if (s < 60)   return 'just now';
      if (s < 3600)  return Math.floor(s / 60) + 'm ago';
      if (s < 86400) return Math.floor(s / 3600) + 'h ago';
      return Math.floor(s / 86400) + 'd ago';
    },

    // ── Color Swatch Buttons ─────────────────────────────────────────────────

    _bindColorSwatches: function () {
      var self = this;

      // Core background color swatches
      var bgSwatches = this.el.querySelectorAll('[data-bg-color]');
      bgSwatches.forEach(function (btn) {
        btn.addEventListener('click', function () {
          self.core.bgColorId = btn.dataset.bgColor;
          bgSwatches.forEach(function (b) { b.classList.toggle('active', b === btn); });
          var label = self.el.querySelector('[data-bg-color-label]');
          if (label) label.textContent = btn.getAttribute('title');
          self.render();
          self._updatePrice();
        });
      });

      // Pro board color swatches
      var boardSwatches = this.el.querySelectorAll('[data-board-color]');
      boardSwatches.forEach(function (btn) {
        btn.addEventListener('click', function () {
          self.pro.boardColorId = btn.dataset.boardColor;
          boardSwatches.forEach(function (b) { b.classList.toggle('active', b === btn); });
          var label = self.el.querySelector('[data-board-color-label]');
          if (label) label.textContent = btn.getAttribute('title');
          self.render();
          self._updatePrice();
        });
      });

      // Pro nameplate color swatches
      var npSwatches = this.el.querySelectorAll('[data-np-color]');
      npSwatches.forEach(function (btn) {
        btn.addEventListener('click', function () {
          self.pro.npColorId = btn.dataset.npColor;
          npSwatches.forEach(function (b) { b.classList.toggle('active', b === btn); });
          var label = self.el.querySelector('[data-np-color-label]');
          if (label) label.textContent = btn.getAttribute('title');
          self.render();
          self._updatePrice();
        });
      });
    },

    // ── Mobile Header (back, product label, mode tabs) ──────────────────────

    _bindMobileHeader: function () {
      var self = this;
      var hdr = document.querySelector('[data-builder-hdr]');
      if (!hdr) return;

      // Back button — goes to wizard or browser back
      var backBtn = hdr.querySelector('[data-builder-back]');
      if (backBtn) {
        backBtn.addEventListener('click', function () {
          var wizard = document.querySelector('[data-build-wizard]');
          if (wizard) {
            self.el.classList.add('dsb__panel--hidden');
            hdr.classList.add('dsb__panel--hidden');
            var switcher = document.querySelector('[data-product-switcher]');
            if (switcher) switcher.classList.add('dsb__panel--hidden');
            wizard.style.display = '';
            // Go back to step 1
            self._showWizardStep(1);
            var url = new URL(window.location);
            url.searchParams.delete('product');
            url.searchParams.delete('template');
            window.history.replaceState({}, '', url);
          } else {
            window.history.back();
          }
        });
      }

      // Mobile mode tabs
      hdr.querySelectorAll('[data-mobile-tab]').forEach(function (tab) {
        tab.addEventListener('click', function () {
          var newMode = tab.dataset.mobileTab;
          self._switchMode(newMode);
          self.render();
          self._updatePrice();
          // Always scroll to top (step 1) on tab switch
          window.scrollTo({ top: 0, behavior: 'smooth' });
          // Sync mobile header tabs
          hdr.querySelectorAll('[data-mobile-tab]').forEach(function (t) {
            t.classList.toggle('active', t.dataset.mobileTab === newMode);
          });
          // Update product label
          var labelEl = hdr.querySelector('[data-builder-product-label]');
          if (labelEl) {
            var names = { pro: 'Pro Display', core: 'Core Display', nameplates: 'Nameplates' };
            labelEl.textContent = names[newMode] || 'Display Builder';
          }
          // Update URL
          var url = new URL(window.location);
          url.searchParams.set('product', newMode);
          url.searchParams.delete('template');
          window.history.replaceState({}, '', url);
        });
      });
    },

    _updateMobileHeaderLabel: function () {
      var hdr = document.querySelector('[data-builder-hdr]');
      if (!hdr) return;
      var labelEl = hdr.querySelector('[data-builder-product-label]');
      if (labelEl) {
        var names = { pro: 'Pro Display', core: 'Core Display', nameplates: 'Nameplates' };
        labelEl.textContent = names[this.mode] || 'Display Builder';
      }
      hdr.querySelectorAll('[data-mobile-tab]').forEach(function (t) {
        t.classList.toggle('active', t.dataset.mobileTab === this.mode);
      }.bind(this));
    },

    // ── Mode Toggle ───────────────────────────────────────────────────────────

    _bindMode: function () {
      var self = this;
      function handleModeSwitch(btn) {
        self._switchMode(btn.dataset.mode);
        self.render();
        self._updatePrice();
        // Always scroll to top of sidebar (step 1) on mode switch
        var sidebar = self.el.querySelector('.dsb__sidebar');
        if (sidebar) {
          sidebar.scrollTop = 0;
          window.scrollTo({ top: 0, behavior: 'smooth' });
        }
      }
      // Bind both product switcher cards and any legacy mode buttons
      this.el.querySelectorAll('[data-mode]').forEach(function (btn) {
        if (btn.tagName === 'A') return;
        btn.addEventListener('click', function () { handleModeSwitch(btn); });
      });
      // Also bind product switcher cards (which sit outside the builder el)
      document.querySelectorAll('[data-product-switcher] [data-mode]').forEach(function (btn) {
        if (btn.tagName === 'A') return;
        btn.addEventListener('click', function () { handleModeSwitch(btn); });
      });
    },

    // ── Core Sidebar ──────────────────────────────────────────────────────────

    _bindCoreSidebar: function () {
      var self = this;
      var p = this.el.querySelector('[data-panel="core-sidebar"]');
      if (!p) return;

      p.querySelectorAll('[data-size]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          self.core.size = btn.dataset.size;
          p.querySelectorAll('[data-size]').forEach(function (b) { b.classList.toggle('active', b === btn); });
          self._coreStep2Done = true;
          self._updateStepProgress();
          self.render(); self._updatePrice();
        });
      });

      p.querySelectorAll('[data-corner]').forEach(function (tile) {
        tile.addEventListener('click', function () {
          self.core.corner = tile.dataset.corner;
          p.querySelectorAll('[data-corner]').forEach(function (t) { t.classList.toggle('active', t === tile); });
          self._coreStep1Done = true;
          self._updateCoreStylePreview();
          self._updateStepProgress();
          self.render();
        });
      });

      // Step 3 Continue button — marks step 3 done even if user keeps default color
      var coreStep3Btn = p.querySelector('[data-core-step3-continue]');
      if (coreStep3Btn) {
        coreStep3Btn.addEventListener('click', function () {
          self._coreStep3Done = true;
          self._updateStepProgress();
          // On mobile, scroll to canvas so they see the next step
          if (self._isMobile()) {
            var canvas = self.el.querySelector('.dsb__canvas-area');
            if (canvas) canvas.scrollIntoView({ behavior: 'smooth', block: 'start' });
          }
        });
      }

      // Color swatches are bound in _bindColorSwatches()

      p.querySelectorAll('[data-addon]').forEach(function (row) {
        row.addEventListener('click', function () {
          var key = row.dataset.addon;
          self.core.addons[key] = !self.core.addons[key];
          row.classList.toggle('active', self.core.addons[key]);
          // Show/hide sub-fields
          var sub = p.querySelector('[data-addon-sub="' + key + '"]');
          if (sub) sub.style.display = self.core.addons[key] ? 'block' : 'none';
          self._updatePrice();
        });
      });

      // Keychain type dropdown
      var coreKcSel = p.querySelector('[data-keychain-type]');
      if (coreKcSel) {
        coreKcSel.addEventListener('change', function () {
          self.core.keychainType = coreKcSel.value;
          self._updatePrice();
        });
      }

      // Bizcard text input
      var coreBcInput = p.querySelector('[data-bizcard-text]');
      if (coreBcInput) {
        coreBcInput.addEventListener('input', function () {
          self.core.bizcardText = coreBcInput.value;
        });
      }
    },

    // ── Pro Sidebar ───────────────────────────────────────────────────────────

    _bindProSidebar: function () {
      var self = this;
      var p = this.el.querySelector('[data-panel="pro-sidebar"]');
      if (!p) return;

      p.querySelectorAll('[data-variant]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          self.pro.variant = btn.dataset.variant;
          self._proStep1Done = true;
          p.querySelectorAll('[data-variant]').forEach(function (b) { b.classList.toggle('active', b === btn); });
          // Hide side-by-side compare, show selected variant image
          var compare = p.querySelector('[data-variant-compare]');
          if (compare) compare.style.display = 'none';
          p.querySelectorAll('[data-variant-preview-img]').forEach(function (img) {
            img.style.display = img.dataset.variantPreviewImg === btn.dataset.variant ? '' : 'none';
          });
          // Update frame color swatches visibility based on variant
          self._updateFrameSwatches(p);
          self._updateStepProgress();
          self.render(); self._updatePrice();
        });
      });

      p.querySelectorAll('[data-orient]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          self.pro.orientation = btn.dataset.orient;
          p.querySelectorAll('[data-orient]').forEach(function (b) { b.classList.toggle('active', b === btn); });
          self.render();
        });
      });

      // Frame color swatches
      p.querySelectorAll('[data-frame-color]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          self.pro.frameColorId = btn.dataset.frameColor;
          p.querySelectorAll('[data-frame-color]').forEach(function (b) { b.classList.toggle('active', b === btn); });
          var lbl = p.querySelector('[data-frame-color-label]');
          if (lbl) lbl.textContent = btn.title;
          self.render();
        });
      });

      // Step 2 Continue button — marks step 2 done even if user keeps defaults
      var step2Btn = p.querySelector('[data-step2-continue]');
      if (step2Btn) {
        step2Btn.addEventListener('click', function () {
          self._proStep2Done = true;
          self._updateStepProgress();
        });
      }

      // Color swatches are bound in _bindColorSwatches()

      p.querySelectorAll('[data-addon]').forEach(function (row) {
        row.addEventListener('click', function () {
          var key = row.dataset.addon;
          self.pro.addons[key] = !self.pro.addons[key];
          row.classList.toggle('active', self.pro.addons[key]);
          // Show/hide sub-fields
          var sub = p.querySelector('[data-addon-sub="' + key + '"]');
          if (sub) sub.style.display = self.pro.addons[key] ? 'block' : 'none';
          self._updatePrice();
        });
      });

      // Keychain type dropdown
      var proKcSel = p.querySelector('[data-keychain-type]');
      if (proKcSel) {
        proKcSel.addEventListener('change', function () {
          self.pro.keychainType = proKcSel.value;
          self._updatePrice();
        });
      }

      // Bizcard text input
      var proBcInput = p.querySelector('[data-bizcard-text]');
      if (proBcInput) {
        proBcInput.addEventListener('input', function () {
          self.pro.bizcardText = proBcInput.value;
        });
      }
    },

    _updateFrameSwatches: function (panel) {
      var isMoss = this.pro.variant === 'moss';
      panel.querySelectorAll('.dsb__swatch--std-only').forEach(function (sw) {
        sw.style.display = isMoss ? 'none' : '';
      });
      // If moss and current frame color is standard-only, reset to black
      if (isMoss && ['frame-gray', 'frame-coffee', 'frame-red'].indexOf(this.pro.frameColorId) !== -1) {
        this.pro.frameColorId = 'frame-black';
        panel.querySelectorAll('[data-frame-color]').forEach(function (b) {
          b.classList.toggle('active', b.dataset.frameColor === 'frame-black');
        });
        var lbl = panel.querySelector('[data-frame-color-label]');
        if (lbl) lbl.textContent = 'Black';
      }
    },

    // ── Nameplates Sidebar ────────────────────────────────────────────────────

    _bindNmSidebar: function () {
      var self = this;
      var p = this.el.querySelector('[data-panel="nameplates-sidebar"]');
      if (!p) return;
      var sizeBtns = p.querySelectorAll('[data-nm-size]');
      sizeBtns.forEach(function (btn) {
        btn.addEventListener('click', function () {
          var sz = btn.dataset.nmSize;
          self.nm.nameplateSize = sz;
          sizeBtns.forEach(function (b) { b.classList.toggle('active', b === btn); });
          if (self.nm.selected !== null) {
            var sel = self.nm.items.filter(function (n) { return n.id === self.nm.selected; })[0];
            if (sel) { sel.size = sz; self.render(); }
          }
        });
      });
    },

    // ── Props / Text Panel ────────────────────────────────────────────────────

    _bindPropsPanel: function () {
      var self = this;

      var addTextBtn = this.el.querySelector('.dsb__add-text');
      if (addTextBtn) {
        addTextBtn.addEventListener('click', function () { self._addCoreText(); });
      }

      var addNpBtn = this.el.querySelector('.dsb__add-nameplate');
      if (addNpBtn) {
        addNpBtn.addEventListener('click', function () { self._addProNameplate(); });
      }

      var addNmBtn = this.el.querySelector('.dsb__add-nm');
      if (addNmBtn) {
        addNmBtn.addEventListener('click', function () { self._addNmItem(); });
      }

      var npSizeBtns = this.el.querySelectorAll('[data-np-size]');
      npSizeBtns.forEach(function (btn) {
        btn.addEventListener('click', function () {
          var sz = btn.dataset.npSize;
          self.pro.nameplateSize = sz;
          npSizeBtns.forEach(function (b) { b.classList.toggle('active', b === btn); });
          // Also update currently selected nameplate
          if (self.pro.selected !== null) {
            var sel = self.pro.nameplates.filter(function (n) { return n.id === self.pro.selected; })[0];
            if (sel) { sel.size = sz; self.render(); }
          }
          // Recalc counter (button label changes) and price (if selection is an extra plate)
          self._updateNpCounter();
          self._updatePrice();
        });
      });
    },

    // ── Core Text Blocks ──────────────────────────────────────────────────────

    _addCoreText: function () {
      var self = this;
      var block = {
        id: Date.now(), text: 'Your Text',
        x: this.W / 2, y: this.H / 2,
        font: 'helvetica', size: 22,
        bold: false, italic: false, colorId: 'white',
      };
      this.core.textBlocks.unshift(block);
      this.core.selected = block.id;
      // Prepend the new item directly — don't re-render the whole list (would destroy focused inputs)
      var list = this.el.querySelector('.dsb__text-list--core');
      if (list) {
        list.querySelectorAll('.dsb__text-item').forEach(function (i) { i.classList.remove('active'); });
        var item = self._makeCoreTextItem(block);
        item.classList.add('active');
        list.insertBefore(item, list.firstChild || null);
        item.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      }
      this.render();
      this._updateMobileBar();
      this._updateCoreCta();
    },

    _makeCoreTextItem: function (block) {
      var self = this;
      return this._makeTextItem(block,
        function () { // onRemove
          self.core.textBlocks = self.core.textBlocks.filter(function (b) { return b.id !== block.id; });
          if (self.core.selected === block.id) self.core.selected = null;
          var el = self.el.querySelector('.dsb__text-item[data-id="' + block.id + '"]');
          if (el && el.parentNode) el.parentNode.removeChild(el);
          self.render();
          self._updateMobileBar();
          self._updateCoreCta();
        },
        function () { // onSelect
          self.core.selected = block.id;
          self._syncCoreSelection();
          self.render();
        },
        function () { // onDuplicate
          self._duplicateCoreText(block);
          self._updateMobileBar();
          self._updateCoreCta();
        }
      );
    },

    _duplicateCoreText: function (src) {
      var self = this;
      var dup = {
        id: Date.now(), text: src.text,
        x: src.x + 14, y: src.y + 14,
        font: src.font, size: src.size,
        bold: src.bold, italic: src.italic, colorId: src.colorId,
      };
      this.core.textBlocks.unshift(dup);
      this.core.selected = dup.id;
      var list = this.el.querySelector('.dsb__text-list--core');
      if (list) {
        list.querySelectorAll('.dsb__text-item').forEach(function (i) { i.classList.remove('active'); });
        var item = self._makeCoreTextItem(dup);
        item.classList.add('active');
        list.insertBefore(item, list.firstChild || null);
        item.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      }
      this.render();
    },

    _syncCoreSelection: function () {
      var self = this;
      var list = this.el.querySelector('.dsb__text-list--core');
      if (!list) return;
      list.querySelectorAll('.dsb__text-item').forEach(function (item) {
        item.classList.toggle('active', String(item.dataset.id) === String(self.core.selected));
      });
    },

    _renderCoreTextList: function () {
      var self = this;
      var list = this.el.querySelector('.dsb__text-list--core');
      if (!list) return;
      list.innerHTML = '';
      this.core.textBlocks.forEach(function (block) {
        var item = self._makeCoreTextItem(block);
        item.classList.toggle('active', self.core.selected === block.id);
        list.appendChild(item);
      });
    },

    // ── Pro Nameplates ────────────────────────────────────────────────────────

    _addProNameplate: function () {
      var self = this;
      var board = this._getBoardRect();
      var np = {
        id: Date.now(), text: 'Name / Item',
        x: board.x + board.w / 2,
        y: board.y + 40 + this.pro.nameplates.length * 60,
        size: this.pro.nameplateSize,
        corner: 'rounded',
        font: 'helvetica', textSize: 16,
        bold: false, italic: false, colorId: 'white',
        npColorId: this.pro.npColorId,
        nfc: false, nfcUrl: '',
      };
      np.y = Math.min(np.y, board.y + board.h - 30);
      this.pro.nameplates.unshift(np);
      this.pro.selected = np.id;
      // Prepend directly — don't re-render the whole list
      var list = this.el.querySelector('.dsb__text-list--pro');
      if (list) {
        list.querySelectorAll('.dsb__text-item').forEach(function (i) { i.classList.remove('active'); });
        var item = self._makeProNpItem(np);
        item.classList.add('active');
        list.insertBefore(item, list.firstChild || null);
        item.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      }
      this._syncProSizeBtns();
      this._updateNpCounter();
      this._updateProNameplateAccess();
      this.render();
    },

    _makeProNpItem: function (np) {
      var self = this;
      var item = document.createElement('div');
      item.className = 'dsb__text-item';
      item.dataset.id = np.id;

      np.npColorId = np.npColorId || self.pro.npColorId || 'matte-black';

      item.innerHTML =
        '<div class="dsb__text-item-row">' +
          '<input class="dsb__text-input" type="text" value="' + self._esc(np.text) + '" placeholder="Nameplate text">' +
          '<button class="dsb__text-dup" title="Duplicate">\u29c9</button>' +
          '<button class="dsb__text-remove" title="Remove">\u00d7</button>' +
        '</div>' +
        '<div class="dsb__text-item-controls">' +
          '<div class="dsb__np-sz-row">' +
            '<span class="dsb__tiny-label">Size</span>' +
            '<div class="dsb__np-sz-btns">' +
              '<button class="dsb__np-sz-btn' + (np.size === 'small'  ? ' active' : '') + '" data-sz="small">S</button>' +
              '<button class="dsb__np-sz-btn' + (np.size === 'medium' ? ' active' : '') + '" data-sz="medium">M</button>' +
              '<button class="dsb__np-sz-btn' + (np.size === 'large'  ? ' active' : '') + '" data-sz="large">L</button>' +
            '</div>' +
          '</div>' +
          '<select class="dsb__font-select">' +
            FONTS.map(function (f) {
              return '<option value="' + f.id + '"' + (np.font === f.id ? ' selected' : '') + '>' + f.name + '</option>';
            }).join('') +
          '</select>' +
          '<div class="dsb__size-row">' +
            '<input type="range" class="dsb__size-slider" min="8" max="36" value="' + (np.textSize || 16) + '" step="1">' +
            '<span class="dsb__size-val">' + (np.textSize || 16) + 'px</span>' +
          '</div>' +
          '<div class="dsb__style-row">' +
            '<button class="dsb__bold-btn' + (np.bold ? ' active' : '') + '">B</button>' +
            '<button class="dsb__italic-btn' + (np.italic ? ' active' : '') + '">I</button>' +
          '</div>' +
          '<div class="dsb__color-row">' +
            '<label class="dsb__tiny-label">Plate Color</label>' +
            '<select class="dsb__np-bg-select">' +
              NP_COLORS.map(function (c) {
                return '<option value="' + c.id + '"' + (np.npColorId === c.id ? ' selected' : '') + '>' + c.name + '</option>';
              }).join('') +
            '</select>' +
          '</div>' +
          '<div class="dsb__color-row" style="margin-top:4px;">' +
            '<label class="dsb__tiny-label">Text Color</label>' +
            '<select class="dsb__text-color-select">' +
              TEXT_COLORS.map(function (c) {
                return '<option value="' + c.id + '"' + (np.colorId === c.id ? ' selected' : '') + '>' + c.name + '</option>';
              }).join('') +
            '</select>' +
          '</div>' +
          '<div class="dsb__color-row" style="margin-top:4px;">' +
            '<select class="dsb__np-corner-select">' +
              '<option value="rounded"' + (np.corner === 'rounded' ? ' selected' : '') + '>Rounded corners</option>' +
              '<option value="square"'  + (np.corner === 'square'  ? ' selected' : '') + '>Square corners</option>' +
              '<option value="pill"'    + (np.corner === 'pill'    ? ' selected' : '') + '>Pill shape</option>' +
            '</select>' +
          '</div>' +
          '<div class="dsb__nfc-row">' +
            '<span class="dsb__tiny-label">Add NFC chip?</span>' +
            '<div class="dsb__nfc-btns">' +
              '<button class="dsb__nfc-btn' + (!np.nfc ? ' active' : '') + '" data-nfc-val="no">No</button>' +
              '<button class="dsb__nfc-btn' + (np.nfc  ? ' active' : '') + '" data-nfc-val="yes">Yes (+$' + (ADDON_PRICES.nfcEmbed || 25) + ')</button>' +
            '</div>' +
          '</div>' +
          '<div class="dsb__nfc-url-row"' + (np.nfc ? '' : ' style="display:none"') + '>' +
            '<input type="url" class="dsb__nfc-url-input" placeholder="https://your-url.com" value="' + self._esc(np.nfcUrl || '') + '">' +
          '</div>' +
        '</div>';

      // Text input
      var input = item.querySelector('.dsb__text-input');
      input.addEventListener('input', function () { np.text = input.value; self.render(); });
      input.addEventListener('focus', function () {
        np._id = np.id;
        self.pro.selected = np.id;
        self._syncProSelection();
        self._syncProSizeBtns();
        self.render();
      });

      // Plate size buttons (per-item)
      item.querySelectorAll('[data-sz]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          np.size = btn.dataset.sz;
          item.querySelectorAll('[data-sz]').forEach(function (b) { b.classList.toggle('active', b === btn); });
          self._updateNpCounter();
          self._updatePrice();
          self.render();
        });
      });

      // Duplicate
      item.querySelector('.dsb__text-dup').addEventListener('click', function () {
        self._duplicateProNp(np);
      });

      // Remove
      item.querySelector('.dsb__text-remove').addEventListener('click', function () {
        self.pro.nameplates = self.pro.nameplates.filter(function (n) { return n.id !== np.id; });
        if (self.pro.selected === np.id) self.pro.selected = null;
        var el = self.el.querySelector('.dsb__text-item[data-id="' + np.id + '"]');
        if (el && el.parentNode) el.parentNode.removeChild(el);
        self._updateNpCounter();
        self._updatePrice();
        self._updateProNameplateAccess();
        self.render();
      });

      // Font
      item.querySelector('.dsb__font-select').addEventListener('change', function (e) {
        np.font = e.target.value; self.render();
      });

      // Size slider
      var slider = item.querySelector('.dsb__size-slider');
      var sizeVal = item.querySelector('.dsb__size-val');
      slider.addEventListener('input', function () {
        np.textSize = parseInt(slider.value, 10);
        sizeVal.textContent = np.textSize + 'px';
        self.render();
      });

      // Bold / Italic
      item.querySelector('.dsb__bold-btn').addEventListener('click', function (e) {
        np.bold = !np.bold;
        e.currentTarget.classList.toggle('active', np.bold);
        self.render();
      });
      item.querySelector('.dsb__italic-btn').addEventListener('click', function (e) {
        np.italic = !np.italic;
        e.currentTarget.classList.toggle('active', np.italic);
        self.render();
      });

      // Text color
      var colorSel = item.querySelector('.dsb__text-color-select');
      colorSel.addEventListener('change', function () {
        np.colorId = colorSel.value; self.render();
      });

      // Corner style
      var cornerSel = item.querySelector('.dsb__np-corner-select');
      cornerSel.addEventListener('change', function () {
        np.corner = cornerSel.value; self.render();
      });

      // Plate color
      var npBgSel = item.querySelector('.dsb__np-bg-select');
      if (npBgSel) {
        npBgSel.addEventListener('change', function () {
          np.npColorId = npBgSel.value; self.render();
        });
      }

      // NFC toggle
      item.querySelectorAll('[data-nfc-val]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          np.nfc = btn.dataset.nfcVal === 'yes';
          item.querySelectorAll('[data-nfc-val]').forEach(function (b) {
            b.classList.toggle('active', b.dataset.nfcVal === (np.nfc ? 'yes' : 'no'));
          });
          var urlRow = item.querySelector('.dsb__nfc-url-row');
          if (urlRow) urlRow.style.display = np.nfc ? '' : 'none';
          self._updatePrice(); self.render();
        });
      });

      // NFC URL
      var nfcInput = item.querySelector('.dsb__nfc-url-input');
      if (nfcInput) {
        nfcInput.addEventListener('input', function () { np.nfcUrl = nfcInput.value; });
      }

      return item;
    },

    _updateNpCounter: function () {
      var count = this.pro.nameplates.length;
      var free  = Math.min(count, NP_FREE_LIMIT);
      var extra = Math.max(0, count - NP_FREE_LIMIT);

      // Track element refs
      var panel = this.el.querySelector('[data-panel="pro-text"]');
      if (!panel) return;
      var track     = panel.querySelector('.dsb__np-quota-track');
      var countEl   = panel.querySelector('.dsb__np-quota-count');
      var extraEl   = panel.querySelector('.dsb__np-quota-extra');
      var noteEl    = panel.querySelector('.dsb__np-quota-note');
      var extraNote = panel.querySelector('.dsb__np-extra-note');
      var addBtn    = panel.querySelector('.dsb__add-nameplate');

      // Progress bar — gradient painted directly on the track element
      var pct = Math.round(Math.min(free / NP_FREE_LIMIT, 1) * 100);
      if (track) track.style.background = 'linear-gradient(to right, #c8a96e ' + pct + '%, rgba(255,255,255,0.07) ' + pct + '%)';

      // Count label
      if (countEl) countEl.textContent = free + ' / ' + NP_FREE_LIMIT + ' included free';

      // Extra badge
      if (extra > 0) {
        var extraCost = 0;
        this.pro.nameplates.slice(NP_FREE_LIMIT).forEach(function (np) {
          extraCost += NP_EXTRA_PRICES[np.size] || NP_EXTRA_PRICES.medium;
        });
        if (extraEl) { extraEl.textContent = '+' + extra + ' extra ($' + extraCost + ')'; extraEl.style.display = ''; }
        if (noteEl)  noteEl.style.display = 'none';
        if (extraNote) extraNote.style.display = '';
      } else {
        if (extraEl) extraEl.style.display = 'none';
        if (noteEl)  noteEl.style.display = '';
        if (extraNote) extraNote.style.display = 'none';
      }

      // Add button label
      if (addBtn) {
        if (count >= NP_FREE_LIMIT) {
          addBtn.textContent = '+ Add nameplate (extra charges apply)';
        } else {
          addBtn.textContent = '+ Add nameplate';
        }
      }
    },

    _syncProSelection: function () {
      var self = this;
      var list = this.el.querySelector('.dsb__text-list--pro');
      if (!list) return;
      list.querySelectorAll('.dsb__text-item').forEach(function (item) {
        item.classList.toggle('active', String(item.dataset.id) === String(self.pro.selected));
      });
    },

    _syncProSizeBtns: function () {
      var self = this;
      var sel = this.pro.nameplates.filter(function (n) { return n.id === self.pro.selected; })[0];
      var activeSize = sel ? sel.size : this.pro.nameplateSize;
      this.el.querySelectorAll('[data-np-size]').forEach(function (btn) {
        btn.classList.toggle('active', btn.dataset.npSize === activeSize);
      });
    },

    _renderProNpList: function () {
      var self = this;
      var list = this.el.querySelector('.dsb__text-list--pro');
      if (!list) return;
      list.innerHTML = '';
      this.pro.nameplates.forEach(function (np) {
        var item = self._makeProNpItem(np);
        item.classList.toggle('active', self.pro.selected === np.id);
        list.appendChild(item);
      });
    },

    _duplicateProNp: function (src) {
      var self = this;
      var board = this._getBoardRect();
      var dup = {
        id: Date.now(), text: src.text,
        x: Math.min(src.x + 14, board.x + board.w - 20),
        y: Math.min(src.y + 14, board.y + board.h - 20),
        size: src.size, corner: src.corner,
        font: src.font, textSize: src.textSize,
        bold: src.bold, italic: src.italic, colorId: src.colorId,
        npColorId: src.npColorId,
        nfc: false, nfcUrl: '',
      };
      this.pro.nameplates.unshift(dup);
      this.pro.selected = dup.id;
      var list = this.el.querySelector('.dsb__text-list--pro');
      if (list) {
        list.querySelectorAll('.dsb__text-item').forEach(function (i) { i.classList.remove('active'); });
        var item = self._makeProNpItem(dup);
        item.classList.add('active');
        list.insertBefore(item, list.firstChild || null);
        item.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      }
      this._syncProSizeBtns();
      this._updateNpCounter();
      this._updatePrice();
      this.render();
    },

    // ── Shared Text Item Builder ──────────────────────────────────────────────

    _makeTextItem: function (block, onRemove, onSelect, onDuplicate) {
      var self = this;
      var item = document.createElement('div');
      item.className = 'dsb__text-item';
      item.dataset.id = block.id;

      var maxSize = block.size !== undefined ? block.size : (block.textSize || 22);
      var sizeKey = block.size !== undefined ? 'size' : 'textSize';

      var curVal = (block.curve !== undefined) ? Math.max(0, block.curve) : 0;

      item.innerHTML =
        '<div class="dsb__text-item-row">' +
          '<input class="dsb__text-input" type="text" value="' + self._esc(block.text) + '" placeholder="Text">' +
          '<button class="dsb__text-dup" title="Duplicate">\u29c9</button>' +
          '<button class="dsb__text-remove" title="Remove">\u00d7</button>' +
        '</div>' +
        '<div class="dsb__text-item-controls">' +
          '<div class="dsb__ie-row">' +
            '<label class="dsb__ie-label">Font</label>' +
            '<select class="dsb__font-select dsb__ie-select">' +
              FONTS.map(function (f) {
                return '<option value="' + f.id + '"' + (block.font === f.id ? ' selected' : '') +
                       ' style="font-family:' + f.css + '">' + f.name + '</option>';
              }).join('') +
            '</select>' +
          '</div>' +
          '<div class="dsb__ie-row-inline">' +
            '<div class="dsb__ie-half">' +
              '<label class="dsb__ie-label">Size</label>' +
              '<div class="dsb__size-row">' +
                '<input type="range" class="dsb__size-slider" min="10" max="48" value="' + maxSize + '" step="1">' +
                '<span class="dsb__size-val">' + maxSize + 'px</span>' +
              '</div>' +
            '</div>' +
            '<div class="dsb__ie-half">' +
              '<label class="dsb__ie-label">Style</label>' +
              '<div class="dsb__style-row">' +
                '<button class="dsb__bold-btn' + (block.bold ? ' active' : '') + '">B</button>' +
                '<button class="dsb__italic-btn' + (block.italic ? ' active' : '') + '">I</button>' +
              '</div>' +
            '</div>' +
          '</div>' +
          '<div class="dsb__ie-row">' +
            '<label class="dsb__ie-label">Text Color</label>' +
            '<div class="dsb__np-ie-tcolors dsb__tcolor-row">' +
              TEXT_COLORS.map(function (c) {
                return '<button type="button" class="dsb__np-ie-tcolor' + (block.colorId === c.id ? ' active' : '') + '" data-text-color="' + c.id + '" style="background:' + c.hex + '" title="' + c.name + '"></button>';
              }).join('') +
            '</div>' +
          '</div>' +
          '<div class="dsb__ie-row">' +
            '<label class="dsb__ie-label">Curve <span class="dsb__ie-sub">(for arched or curved layouts)</span></label>' +
            '<div class="dsb__size-row">' +
              '<input type="range" class="dsb__curve-slider" min="0" max="100" value="' + curVal + '" step="5">' +
              '<span class="dsb__curve-val">' + (curVal === 0 ? 'Off' : curVal) + '</span>' +
            '</div>' +
          '</div>' +
        '</div>';

      var input = item.querySelector('.dsb__text-input');
      input.addEventListener('input', function () { block.text = input.value; self.render(); });
      input.addEventListener('click', onSelect);

      var dupBtn = item.querySelector('.dsb__text-dup');
      if (dupBtn) dupBtn.addEventListener('click', function () { if (onDuplicate) onDuplicate(); });

      item.querySelector('.dsb__text-remove').addEventListener('click', onRemove);

      var fontSel = item.querySelector('.dsb__font-select');
      // Reflect the selected option's font in the closed dropdown
      var _applyFontFace = function () {
        var opt = fontSel.options[fontSel.selectedIndex];
        if (opt && opt.style && opt.style.fontFamily) fontSel.style.fontFamily = opt.style.fontFamily;
      };
      _applyFontFace();
      fontSel.addEventListener('change', function (e) {
        block.font = e.target.value;
        _applyFontFace();
        self.render();
      });

      var slider = item.querySelector('.dsb__size-slider');
      var sizeVal = item.querySelector('.dsb__size-val');
      slider.addEventListener('input', function () {
        block[sizeKey] = parseInt(slider.value, 10);
        sizeVal.textContent = block[sizeKey] + 'px';
        self.render();
      });

      var curveSlider = item.querySelector('.dsb__curve-slider');
      var curveVal = item.querySelector('.dsb__curve-val');
      if (curveSlider) {
        curveSlider.addEventListener('input', function () {
          var v = Math.max(0, parseInt(curveSlider.value, 10));
          block.curve = v;
          curveVal.textContent = v === 0 ? 'Off' : v;
          self.render();
        });
      }

      item.querySelector('.dsb__bold-btn').addEventListener('click', function (e) {
        block.bold = !block.bold;
        e.currentTarget.classList.toggle('active', block.bold);
        self.render();
      });
      item.querySelector('.dsb__italic-btn').addEventListener('click', function (e) {
        block.italic = !block.italic;
        e.currentTarget.classList.toggle('active', block.italic);
        self.render();
      });

      item.querySelectorAll('[data-text-color]').forEach(function (sw) {
        sw.addEventListener('click', function () {
          block.colorId = sw.dataset.textColor;
          item.querySelectorAll('[data-text-color]').forEach(function (s) { s.classList.toggle('active', s === sw); });
          self.render();
        });
      });

      return item;
    },

    // ── Canvas ────────────────────────────────────────────────────────────────

    _bindCanvas: function () {
      var self = this;
      this.canvas.addEventListener('mousedown',  function (e) { self._fromTouch = false; self._onDown(e); });
      this.canvas.addEventListener('mousemove',  function (e) { self._onMove(e); });
      this.canvas.addEventListener('mouseup',    function ()  { self._onUp(); });
      this.canvas.addEventListener('mouseleave', function ()  { self._onUp(); });
      this.canvas.addEventListener('touchstart', function (e) { self._fromTouch = true; self._onDown(e.touches[0]); }, { passive: true });
      this.canvas.addEventListener('touchmove',  function (e) { e.preventDefault(); self._onMove(e.touches[0]); }, { passive: false });
      this.canvas.addEventListener('touchend',   function ()  { self._onUp(); });
    },

    _pos: function (e) {
      var r = this.canvas.getBoundingClientRect();
      return {
        x: (e.clientX - r.left) * (this.W / r.width),
        y: (e.clientY - r.top)  * (this.H / r.height),
      };
    },

    _onDown: function (e) {
      var p = this._pos(e);
      if      (this.mode === 'core')       { this._hitCore(p.x, p.y); }
      else if (this.mode === 'pro')        { this._hitPro(p.x, p.y); }
      else                                 { this._hitNm(p.x, p.y); }
    },

    _hitCore: function (x, y) {
      var ctx = this.ctx;
      for (var i = this.core.textBlocks.length - 1; i >= 0; i--) {
        var b = this.core.textBlocks[i];
        ctx.font = this._fontStr(b.font, b.bold, b.italic, b.size);
        var tw = ctx.measureText(b.text).width;
        var th = b.size;
        if (x >= b.x - tw / 2 - 8 && x <= b.x + tw / 2 + 8 &&
            y >= b.y - th / 2 - 8 && y <= b.y + th / 2 + 8) {
          this.core.selected = b.id;
          this.dragging = { type: 'core', obj: b };
          this.dragOff = { x: x - b.x, y: y - b.y };
          this._syncCoreSelection();
          this.render();
          if (this._isMobile()) {
            // On mobile, open the CORE text editor slideup for the tapped block
            this._openTextPanelForBlock(b);
          } else {
            var selEl = this.el.querySelector('.dsb__text-item[data-id="' + b.id + '"]');
            if (selEl) selEl.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
          }
          return;
        }
      }
      this.core.selected = null;
      this._syncCoreSelection();
      this.render();
    },

    _hitPro: function (x, y) {
      var NP = { small: [100, 30], medium: [140, 38], large: [200, 44] };
      for (var i = this.pro.nameplates.length - 1; i >= 0; i--) {
        var np = this.pro.nameplates[i];
        var dims = NP[np.size] || NP.medium;
        var hw = dims[0] / 2, hh = dims[1] / 2;
        if (x >= np.x - hw - 6 && x <= np.x + hw + 6 &&
            y >= np.y - hh - 6 && y <= np.y + hh + 6) {
          this.pro.selected = np.id;
          this.dragging = { type: 'pro', obj: np };
          this.dragOff = { x: x - np.x, y: y - np.y };
          this._syncProSelection();
          this._syncProSizeBtns();
          this.render();
          if (this._isMobile()) {
            // On mobile, open slideup editor for the tapped nameplate
            this._openNpPanelForPlate(np);
          } else {
            var selEl = this.el.querySelector('.dsb__text-item[data-id="' + np.id + '"]');
            if (selEl) selEl.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
          }
          return;
        }
      }
      this.pro.selected = null;
      this._syncProSelection();
      this._syncProSizeBtns();
      this.render();
    },

    _onMove: function (e) {
      if (!this.dragging || this.mode === 'nameplates') return;
      var p = this._pos(e);
      if (this.dragging.type === 'core') {
        this.dragging.obj.x = p.x - this.dragOff.x;
        this.dragging.obj.y = p.y - this.dragOff.y;
      } else {
        var board = this._getBoardRect();
        this.dragging.obj.x = Math.max(board.x + 20, Math.min(board.x + board.w - 20, p.x - this.dragOff.x));
        this.dragging.obj.y = Math.max(board.y + 20, Math.min(board.y + board.h - 20, p.y - this.dragOff.y));
      }
      this.render();
    },

    _onUp: function () { this.dragging = null; },

    _getBoardRect: function () {
      // Scale board to fill ~64% of canvas, maintaining real-world aspect ratio
      var isLand = this.pro.orientation === 'landscape';
      var aspect = isLand ? (327 / 280) : (280 / 327);
      var bw = Math.round(this.W * 0.64);
      var bh = Math.round(bw / aspect);
      var maxH = Math.round(this.H * 0.80);
      if (bh > maxH) { bh = maxH; bw = Math.round(bh * aspect); }
      return { x: Math.round((this.W - bw) / 2), y: Math.round((this.H - bh) / 2), w: bw, h: bh };
    },

    // ── Render ────────────────────────────────────────────────────────────────

    render: function () {
      if (!this.ctx) return;
      this.el.dataset.activeMode = this.mode;
      // Show/hide board nav
      var boardNav = this.el.querySelector('[data-board-nav]');
      if (boardNav) boardNav.style.display = (this.mode === 'nameplates') ? 'flex' : 'none';
      this.ctx.clearRect(0, 0, this.W, this.H);
      if      (this.mode === 'core')       { this._renderCore(); }
      else if (this.mode === 'pro')        { this._renderPro(); }
      else                                 { this._renderNameplates(); }
      this._updateCanvasCta();
    },

    // Returns display box dimensions scaled to fill the canvas nicely for each size
    _getCoreDims: function () {
      var W = this.W, H = this.H;
      var PAD = 22, FOOTER = 16;
      var avW = W - PAD * 2;
      var avH = H - PAD * 2 - FOOTER;
      // S/M/L are meaningfully spread: small is compact, large nearly fills the canvas
      var SCALES = { S: 0.46, M: 0.68, L: 0.92 };
      var ASPECT = 0.786; // width / height (portrait)
      var sc = SCALES[this.core.size] || SCALES.M;
      // Height-driven (portrait display in square canvas)
      var dh = Math.round(avH * sc);
      var dw = Math.round(dh * ASPECT);
      // Clamp so it never overflows width
      if (dw > avW * 0.94) { dw = Math.round(avW * 0.94); dh = Math.round(dw / ASPECT); }
      return { dw: dw, dh: dh, dx: Math.round((W - dw) / 2), dy: Math.round((H - dh) / 2) };
    },

    _renderCore: function () {
      var ctx = this.ctx, W = this.W, H = this.H;

      // Background
      ctx.fillStyle = '#f0ebe1';
      ctx.fillRect(0, 0, W, H);

      // Subtle grid lines
      ctx.strokeStyle = 'rgba(0,0,0,0.04)';
      ctx.lineWidth = 1;
      for (var gx = 0; gx < W; gx += 40) { ctx.beginPath(); ctx.moveTo(gx, 0); ctx.lineTo(gx, H); ctx.stroke(); }
      for (var gy = 0; gy < H; gy += 40) { ctx.beginPath(); ctx.moveTo(0, gy); ctx.lineTo(W, gy); ctx.stroke(); }

      var dims = this._getCoreDims();
      var dw = dims.dw, dh = dims.dh, dx = dims.dx, dy = dims.dy;
      var corner = this.core.corner;
      var filHex = this._bgColorHex(this.core.bgColorId);

      ctx.save();
      ctx.shadowColor = 'rgba(0,0,0,0.28)';
      ctx.shadowBlur  = 22;
      ctx.shadowOffsetX = 4;
      ctx.shadowOffsetY = 10;

      ctx.beginPath();
      if (corner === 'arch') {
        var ar = dw / 2;
        ctx.moveTo(dx, dy + ar);
        ctx.arc(dx + dw / 2, dy + ar, ar, Math.PI, 0, false);
        ctx.lineTo(dx + dw, dy + dh);
        ctx.lineTo(dx, dy + dh);
        ctx.closePath();
      } else if (corner === 'rounded') {
        var rr = Math.round(dw * 0.065);
        ctx.moveTo(dx + rr, dy);
        ctx.lineTo(dx + dw - rr, dy);
        ctx.quadraticCurveTo(dx + dw, dy, dx + dw, dy + rr);
        ctx.lineTo(dx + dw, dy + dh - rr);
        ctx.quadraticCurveTo(dx + dw, dy + dh, dx + dw - rr, dy + dh);
        ctx.lineTo(dx + rr, dy + dh);
        ctx.quadraticCurveTo(dx, dy + dh, dx, dy + dh - rr);
        ctx.lineTo(dx, dy + rr);
        ctx.quadraticCurveTo(dx, dy, dx + rr, dy);
        ctx.closePath();
      } else {
        ctx.rect(dx, dy, dw, dh);
      }

      var grad = ctx.createLinearGradient(dx, dy, dx + dw, dy + dh);
      grad.addColorStop(0,   this._lighten(filHex, 0.14));
      grad.addColorStop(0.5, filHex);
      grad.addColorStop(1,   this._darken(filHex, 0.18));
      ctx.fillStyle = grad;
      ctx.fill();
      ctx.shadowColor = 'transparent';

      // Resin sheen
      ctx.save();
      ctx.clip();
      var sh = ctx.createLinearGradient(dx, dy, dx + dw * 0.6, dy + dh * 0.35);
      sh.addColorStop(0, 'rgba(255,255,255,0.20)');
      sh.addColorStop(1, 'rgba(255,255,255,0)');
      ctx.fillStyle = sh;
      ctx.fill();
      ctx.restore();

      ctx.restore();

      // Text blocks
      var self = this;
      this.core.textBlocks.forEach(function (block) {
        ctx.save();
        ctx.font      = self._fontStr(block.font, block.bold, block.italic, block.size);
        ctx.fillStyle = self._tcHex(block.colorId);
        ctx.textAlign    = 'center';
        ctx.textBaseline = 'middle';

        var curve = block.curve || 0;
        if (curve !== 0) {
          self._drawCurvedText(ctx, block.text, block.x, block.y, block.size, curve);
        } else {
          ctx.fillText(block.text, block.x, block.y);
        }

        if (self.core.selected === block.id) {
          var tw = ctx.measureText(block.text).width;
          var th = block.size;
          // widen bbox for curved text
          var pad = curve !== 0 ? Math.max(10, Math.abs(curve) * 0.3) : 6;
          ctx.strokeStyle = '#c8a96e';
          ctx.lineWidth   = 1;
          ctx.setLineDash([4, 3]);
          ctx.strokeRect(block.x - tw / 2 - pad, block.y - th / 2 - pad, tw + pad * 2, th + pad * 2);
          ctx.setLineDash([]);
        }
        ctx.restore();
      });

      // Footer label
      ctx.font      = '10px Helvetica Neue, Arial, sans-serif';
      ctx.fillStyle = 'rgba(0,0,0,0.3)';
      ctx.textAlign    = 'center';
      ctx.textBaseline = 'bottom';
      var sizeLabel = this.core.size === 'S' ? 'Small' : this.core.size === 'M' ? 'Medium' : 'Large';
      ctx.fillText(
        'Size: ' + sizeLabel + '  ·  ' + corner.charAt(0).toUpperCase() + corner.slice(1) + ' corners  ·  Resin finish',
        W / 2, H - 8
      );
    },

    _renderPro: function () {
      var ctx = this.ctx, W = this.W, H = this.H;

      // Canvas background
      ctx.fillStyle = '#181818';
      ctx.fillRect(0, 0, W, H);

      var board = this._getBoardRect();
      var bw = board.w, bh = board.h, bx = board.x, by = board.y;

      if (this.pro.variant === 'moss') {
        // ── Outer frame (behind moss)
        var mfHex = this._frameColorHex(this.pro.frameColorId);
        var ofp = 28;
        var ofx = bx - ofp, ofy = by - ofp, ofw = bw + ofp * 2, ofh = bh + ofp * 2;
        ctx.save();
        ctx.shadowColor = 'rgba(0,0,0,0.6)';
        ctx.shadowBlur  = 24;
        ctx.shadowOffsetY = 8;
        ctx.fillStyle = mfHex;
        ctx.fillRect(ofx, ofy, ofw, ofh);
        ctx.shadowColor = 'transparent';
        ctx.restore();
        // ── Moss border
        var mp = 22;
        var mx = bx - mp, my = by - mp, mw = bw + mp * 2, mh = bh + mp * 2;
        ctx.save();
        var mg = ctx.createLinearGradient(mx, my, mx + mw, my + mh);
        mg.addColorStop(0,   '#3d6b3a');
        mg.addColorStop(0.35,'#2d4a2d');
        mg.addColorStop(0.65,'#3a5e35');
        mg.addColorStop(1,   '#273f25');
        ctx.fillStyle = mg;
        ctx.fillRect(mx, my, mw, mh);
        // Moss texture
        ctx.strokeStyle = 'rgba(0,0,0,0.15)';
        ctx.lineWidth = 1;
        for (var ti = 0; ti < 10; ti++) {
          for (var tj = 0; tj < 8; tj++) {
            if ((ti + tj) % 2 === 0) {
              ctx.beginPath();
              ctx.arc(mx + (ti + 0.5) * (mw / 10), my + (tj + 0.5) * (mh / 8), 2.5, 0, Math.PI * 2);
              ctx.stroke();
            }
          }
        }
        // Inner shadow line where moss meets steel
        ctx.strokeStyle = 'rgba(0,0,0,0.5)';
        ctx.lineWidth = 3;
        ctx.strokeRect(bx - 1.5, by - 1.5, bw + 3, bh + 3);
        ctx.restore();
      } else {
        // ── Standard frame with customizable color
        var fp = 24;
        var fx = bx - fp, fy = by - fp, fw = bw + fp * 2, fh = bh + fp * 2;
        var fHex = this._frameColorHex(this.pro.frameColorId);
        var fIsLight = this.pro.frameColorId === 'frame-white';
        ctx.save();
        ctx.shadowColor   = 'rgba(0,0,0,0.75)';
        ctx.shadowBlur    = 30;
        ctx.shadowOffsetY = 10;
        var frameGrad = ctx.createLinearGradient(fx, fy, fx, fy + fh);
        frameGrad.addColorStop(0,   this._lighten(fHex, 0.12));
        frameGrad.addColorStop(0.5, fHex);
        frameGrad.addColorStop(1,   this._darken(fHex, 0.10));
        ctx.fillStyle = frameGrad;
        ctx.fillRect(fx, fy, fw, fh);
        ctx.shadowColor = 'transparent';
        // Outer highlight edge
        ctx.strokeStyle = fIsLight ? 'rgba(0,0,0,0.08)' : 'rgba(255,255,255,0.07)';
        ctx.lineWidth = 1;
        ctx.strokeRect(fx + 0.5, fy + 0.5, fw - 1, fh - 1);
        // Routed channel shadow at inner edge
        ctx.strokeStyle = 'rgba(0,0,0,0.65)';
        ctx.lineWidth = 4;
        ctx.strokeRect(bx - 5, by - 5, bw + 10, bh + 10);
        // Inner raised lip highlight
        ctx.strokeStyle = 'rgba(255,255,255,0.06)';
        ctx.lineWidth = 1;
        ctx.strokeRect(bx - 3.5, by - 3.5, bw + 7, bh + 7);
        ctx.restore();
      }

      // ── Steel board face
      var boardHex = this._boardColorHex(this.pro.boardColorId);
      var isLight  = this.pro.boardColorId === 'board-white';

      ctx.save();
      ctx.shadowColor   = 'rgba(0,0,0,0.5)';
      ctx.shadowBlur    = 12;
      ctx.shadowOffsetY = 3;
      var sg = ctx.createLinearGradient(bx, by, bx + bw, by + bh);
      if (isLight) {
        sg.addColorStop(0,   this._lighten(boardHex, 0.08));
        sg.addColorStop(0.5, boardHex);
        sg.addColorStop(1,   this._darken(boardHex, 0.06));
      } else {
        sg.addColorStop(0,   this._lighten(boardHex, 0.08));
        sg.addColorStop(0.5, boardHex);
        sg.addColorStop(1,   this._darken(boardHex, 0.10));
      }
      ctx.fillStyle = sg;
      ctx.fillRect(bx, by, bw, bh);
      ctx.shadowColor = 'transparent';
      // Steel border line
      ctx.strokeStyle = isLight ? 'rgba(0,0,0,0.15)' : 'rgba(255,255,255,0.10)';
      ctx.lineWidth = 1;
      ctx.strokeRect(bx + 0.5, by + 0.5, bw - 1, bh - 1);
      ctx.restore();

      // ── Empty board — no ghost, the sticky bar handles the CTA

      // ── Nameplates
      var NP_DIMS = { small: [100, 30], medium: [140, 38], large: [200, 44] };
      var self = this;

      this.pro.nameplates.forEach(function (np) {
        var npHex = self._npColorHex(np.npColorId || self.pro.npColorId);
        var dims = NP_DIMS[np.size] || NP_DIMS.medium;
        var npw = dims[0], nph = dims[1];
        var npx = np.x - npw / 2, npy = np.y - nph / 2;
        var corner = np.corner || 'rounded';
        var r = corner === 'square' ? 0 : corner === 'pill' ? nph / 2 : 4;

        ctx.save();
        ctx.shadowColor   = 'rgba(0,0,0,0.50)';
        ctx.shadowBlur    = 10;
        ctx.shadowOffsetY = 4;

        // Nameplate shape path
        ctx.beginPath();
        if (r === 0) {
          ctx.rect(npx, npy, npw, nph);
        } else {
          ctx.moveTo(npx + r, npy);
          ctx.lineTo(npx + npw - r, npy);
          ctx.quadraticCurveTo(npx + npw, npy,       npx + npw, npy + r);
          ctx.lineTo(npx + npw, npy + nph - r);
          ctx.quadraticCurveTo(npx + npw, npy + nph, npx + npw - r, npy + nph);
          ctx.lineTo(npx + r,  npy + nph);
          ctx.quadraticCurveTo(npx, npy + nph,       npx, npy + nph - r);
          ctx.lineTo(npx, npy + r);
          ctx.quadraticCurveTo(npx, npy,             npx + r, npy);
          ctx.closePath();
        }
        var ng = ctx.createLinearGradient(npx, npy, npx, npy + nph);
        ng.addColorStop(0, self._lighten(npHex, 0.12));
        ng.addColorStop(1, self._darken(npHex, 0.12));
        ctx.fillStyle = ng;
        ctx.fill();
        ctx.shadowColor = 'transparent';

        // Sheen overlay
        ctx.save();
        ctx.clip();
        var nsh = ctx.createLinearGradient(npx, npy, npx, npy + nph * 0.5);
        nsh.addColorStop(0, 'rgba(255,255,255,0.16)');
        nsh.addColorStop(1, 'rgba(255,255,255,0)');
        ctx.fillStyle = nsh;
        ctx.fillRect(npx, npy, npw, nph);
        ctx.restore();

        ctx.restore();

        // Selection outline
        if (self.pro.selected === np.id) {
          ctx.strokeStyle = '#c8a96e';
          ctx.lineWidth   = 1.5;
          ctx.setLineDash([4, 3]);
          ctx.strokeRect(npx - 4, npy - 4, npw + 8, nph + 8);
          ctx.setLineDash([]);
        }

        // Text
        var ts = Math.min(np.textSize || 16, nph * 0.60);
        ctx.font         = self._fontStr(np.font, np.bold, np.italic, ts);
        ctx.fillStyle    = self._tcHex(np.colorId);
        ctx.textAlign    = 'center';
        ctx.textBaseline = 'middle';
        ctx.fillText(np.text, np.x, np.y, npw - 14);
      });

      // ── Footer label
      ctx.font      = '10px Helvetica Neue, Arial, sans-serif';
      ctx.fillStyle = 'rgba(255,255,255,0.22)';
      ctx.textAlign    = 'center';
      ctx.textBaseline = 'bottom';
      ctx.fillText('12\u2033 \u00d7 14\u2033 magnetic steel board', W / 2, H - 8);
    },

    // ── Nameplates Mode ───────────────────────────────────────────────────────

    _addNmItem: function () {
      var self = this;
      var nm = {
        id: Date.now(), text: 'Name / Item',
        size: this.nm.nameplateSize,
        corner: 'rounded',
        font: 'helvetica', textSize: 16,
        bold: false, italic: false,
        colorId: 'white',
        npColorId: 'matte-black',
        nfc: false, nfcUrl: '',
      };
      var insertIdx = this._getPageInsertIndex(this.nm.page);
      this.nm.items.splice(insertIdx, 0, nm);
      this.nm.selected = nm.id;
      var list = this.el.querySelector('.dsb__text-list--nm');
      if (list) {
        list.querySelectorAll('.dsb__text-item').forEach(function (i) { i.classList.remove('active'); });
        var item = self._makeNmItem(nm);
        item.classList.add('active');
        var refEl = list.querySelectorAll('.dsb__text-item')[insertIdx] || null;
        list.insertBefore(item, refEl);
        item.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      }
      this._updatePrice();
      this.render();
    },

    _makeNmItem: function (nm) {
      var self = this;
      var item = document.createElement('div');
      item.className = 'dsb__text-item';
      item.dataset.id = nm.id;

      item.innerHTML =
        '<div class="dsb__text-item-row">' +
          '<input class="dsb__text-input" type="text" value="' + self._esc(nm.text) + '" placeholder="Nameplate text">' +
          '<button class="dsb__text-dup" title="Duplicate">\u29c9</button>' +
          '<button class="dsb__text-remove" title="Remove">\u00d7</button>' +
        '</div>' +
        '<div class="dsb__text-item-controls">' +
          '<div class="dsb__np-sz-row">' +
            '<span class="dsb__tiny-label">Size</span>' +
            '<div class="dsb__np-sz-btns">' +
              '<button class="dsb__np-sz-btn' + (nm.size === 'small'  ? ' active' : '') + '" data-sz="small">S</button>' +
              '<button class="dsb__np-sz-btn' + (nm.size === 'medium' ? ' active' : '') + '" data-sz="medium">M</button>' +
              '<button class="dsb__np-sz-btn' + (nm.size === 'large'  ? ' active' : '') + '" data-sz="large">L</button>' +
            '</div>' +
          '</div>' +
          '<select class="dsb__font-select">' +
            FONTS.map(function (f) {
              return '<option value="' + f.id + '"' + (nm.font === f.id ? ' selected' : '') + '>' + f.name + '</option>';
            }).join('') +
          '</select>' +
          '<div class="dsb__size-row">' +
            '<input type="range" class="dsb__size-slider" min="8" max="36" value="' + (nm.textSize || 16) + '" step="1">' +
            '<span class="dsb__size-val">' + (nm.textSize || 16) + 'px</span>' +
          '</div>' +
          '<div class="dsb__style-row">' +
            '<button class="dsb__bold-btn' + (nm.bold ? ' active' : '') + '">B</button>' +
            '<button class="dsb__italic-btn' + (nm.italic ? ' active' : '') + '">I</button>' +
          '</div>' +
          '<div class="dsb__color-row">' +
            '<label class="dsb__tiny-label">Plate Color</label>' +
            '<select class="dsb__np-bg-select">' +
              NP_COLORS.map(function (c) {
                return '<option value="' + c.id + '"' + (nm.npColorId === c.id ? ' selected' : '') + '>' + c.name + '</option>';
              }).join('') +
            '</select>' +
          '</div>' +
          '<div class="dsb__color-row" style="margin-top:4px;">' +
            '<label class="dsb__tiny-label">Text Color</label>' +
            '<select class="dsb__text-color-select">' +
              TEXT_COLORS.map(function (c) {
                return '<option value="' + c.id + '"' + (nm.colorId === c.id ? ' selected' : '') + '>' + c.name + '</option>';
              }).join('') +
            '</select>' +
          '</div>' +
          '<div class="dsb__color-row" style="margin-top:4px;">' +
            '<select class="dsb__np-corner-select">' +
              '<option value="rounded"' + (nm.corner === 'rounded' ? ' selected' : '') + '>Rounded corners</option>' +
              '<option value="square"'  + (nm.corner === 'square'  ? ' selected' : '') + '>Square corners</option>' +
              '<option value="pill"'    + (nm.corner === 'pill'    ? ' selected' : '') + '>Pill shape</option>' +
            '</select>' +
          '</div>' +
          '<div class="dsb__nfc-row">' +
            '<span class="dsb__tiny-label">Add NFC chip?</span>' +
            '<div class="dsb__nfc-btns">' +
              '<button class="dsb__nfc-btn' + (!nm.nfc ? ' active' : '') + '" data-nfc-val="no">No</button>' +
              '<button class="dsb__nfc-btn' + (nm.nfc  ? ' active' : '') + '" data-nfc-val="yes">Yes (+$' + (ADDON_PRICES.nfcEmbed || 25) + ')</button>' +
            '</div>' +
          '</div>' +
          '<div class="dsb__nfc-url-row"' + (nm.nfc ? '' : ' style="display:none"') + '>' +
            '<input type="url" class="dsb__nfc-url-input" placeholder="https://your-url.com" value="' + self._esc(nm.nfcUrl || '') + '">' +
          '</div>' +
        '</div>';

      var input = item.querySelector('.dsb__text-input');
      input.addEventListener('input', function () { nm.text = input.value; self.render(); });
      input.addEventListener('focus', function () {
        self.nm.selected = nm.id;
        self._syncNmSelection();
        self.render();
      });

      // Plate size buttons (per-item)
      item.querySelectorAll('[data-sz]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          nm.size = btn.dataset.sz;
          item.querySelectorAll('[data-sz]').forEach(function (b) { b.classList.toggle('active', b === btn); });
          self._updatePrice();
          self.render();
        });
      });

      item.querySelector('.dsb__text-dup').addEventListener('click', function () {
        self._duplicateNm(nm);
      });

      item.querySelector('.dsb__text-remove').addEventListener('click', function () {
        self.nm.items = self.nm.items.filter(function (n) { return n.id !== nm.id; });
        if (self.nm.selected === nm.id) self.nm.selected = null;
        var el = self.el.querySelector('.dsb__text-item[data-id="' + nm.id + '"]');
        if (el && el.parentNode) el.parentNode.removeChild(el);
        self._updatePrice();
        self.render();
      });

      item.querySelector('.dsb__font-select').addEventListener('change', function (e) {
        nm.font = e.target.value; self.render();
      });

      var slider = item.querySelector('.dsb__size-slider');
      var sizeVal = item.querySelector('.dsb__size-val');
      slider.addEventListener('input', function () {
        nm.textSize = parseInt(slider.value, 10);
        sizeVal.textContent = nm.textSize + 'px';
        self.render();
      });

      item.querySelector('.dsb__bold-btn').addEventListener('click', function (e) {
        nm.bold = !nm.bold; e.currentTarget.classList.toggle('active', nm.bold); self.render();
      });
      item.querySelector('.dsb__italic-btn').addEventListener('click', function (e) {
        nm.italic = !nm.italic; e.currentTarget.classList.toggle('active', nm.italic); self.render();
      });

      var npBgSel = item.querySelector('.dsb__np-bg-select');
      if (npBgSel) npBgSel.addEventListener('change', function () { nm.npColorId = npBgSel.value; self.render(); });

      var colorSel = item.querySelector('.dsb__text-color-select');
      colorSel.addEventListener('change', function () { nm.colorId = colorSel.value; self.render(); });

      var cornerSel = item.querySelector('.dsb__np-corner-select');
      cornerSel.addEventListener('change', function () { nm.corner = cornerSel.value; self.render(); });

      item.querySelectorAll('[data-nfc-val]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          nm.nfc = btn.dataset.nfcVal === 'yes';
          item.querySelectorAll('[data-nfc-val]').forEach(function (b) {
            b.classList.toggle('active', b.dataset.nfcVal === (nm.nfc ? 'yes' : 'no'));
          });
          var urlRow = item.querySelector('.dsb__nfc-url-row');
          if (urlRow) urlRow.style.display = nm.nfc ? '' : 'none';
          self._updatePrice(); self.render();
        });
      });

      var nfcInput = item.querySelector('.dsb__nfc-url-input');
      if (nfcInput) nfcInput.addEventListener('input', function () { nm.nfcUrl = nfcInput.value; });

      return item;
    },

    _renderNmList: function () {
      var self = this;
      var list = this.el.querySelector('.dsb__text-list--nm');
      if (!list) return;
      list.innerHTML = '';
      this.nm.items.forEach(function (nm) {
        var item = self._makeNmItem(nm);
        item.classList.toggle('active', self.nm.selected === nm.id);
        list.appendChild(item);
      });
    },

    _syncNmSelection: function () {
      var self = this;
      var list = this.el.querySelector('.dsb__text-list--nm');
      if (!list) return;
      list.querySelectorAll('.dsb__text-item').forEach(function (item) {
        item.classList.toggle('active', String(item.dataset.id) === String(self.nm.selected));
      });
    },

    _duplicateNm: function (src) {
      var self = this;
      var dup = {
        id: Date.now(), text: src.text,
        size: src.size, corner: src.corner,
        font: src.font, textSize: src.textSize,
        bold: src.bold, italic: src.italic, colorId: src.colorId,
        npColorId: src.npColorId,
        nfc: false, nfcUrl: '',
      };
      var insertIdx = this._getPageInsertIndex(this.nm.page);
      this.nm.items.splice(insertIdx, 0, dup);
      this.nm.selected = dup.id;
      var list = this.el.querySelector('.dsb__text-list--nm');
      if (list) {
        list.querySelectorAll('.dsb__text-item').forEach(function (i) { i.classList.remove('active'); });
        var item = self._makeNmItem(dup);
        item.classList.add('active');
        var refEl = list.querySelectorAll('.dsb__text-item')[insertIdx] || null;
        list.insertBefore(item, refEl);
        item.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      }
      this._updatePrice();
      this.render();
    },

    // ── Board pagination helpers ──────────────────────────────────────────────

    _computeNmPages: function () {
      var NP_DIMS = { small: [100, 30], medium: [140, 38], large: [200, 44] };
      var GAP = 14, PAD_X = 18, PAD_Y = 18;
      var W = this.W, H = this.H;
      var page = 0, x = PAD_X, y = PAD_Y, rowH = 0;
      var map = {};
      this.nm.items.forEach(function (nm) {
        var dims = NP_DIMS[nm.size] || NP_DIMS.medium;
        var npw = dims[0], nph = dims[1];
        if (x + npw > W - PAD_X && x > PAD_X) { y += rowH + GAP; x = PAD_X; rowH = 0; }
        if (y + nph > H - PAD_Y) { page++; x = PAD_X; y = PAD_Y; rowH = 0; }
        map[nm.id] = page;
        x += npw + GAP;
        rowH = Math.max(rowH, nph);
      });
      return { map: map, total: page + 1 };
    },

    _getPageInsertIndex: function (targetPage) {
      var info = this._computeNmPages();
      for (var i = 0; i < this.nm.items.length; i++) {
        if (info.map[this.nm.items[i].id] === targetPage) return i;
      }
      return this.nm.items.length;
    },

    _bindBoardNav: function () {
      var self = this;
      var prevBtn = this.el.querySelector('[data-board-prev]');
      var nextBtn = this.el.querySelector('[data-board-next]');
      if (prevBtn) prevBtn.addEventListener('click', function () {
        if (self.nm.page > 0) { self.nm.page--; self.render(); }
      });
      if (nextBtn) nextBtn.addEventListener('click', function () {
        var info = self._computeNmPages();
        if (self.nm.page < info.total - 1) { self.nm.page++; self.render(); }
      });
    },

    _hitNm: function (x, y) {
      for (var i = this._nmPositions.length - 1; i >= 0; i--) {
        var p = this._nmPositions[i];
        if (x >= p.cx - p.w / 2 - 4 && x <= p.cx + p.w / 2 + 4 &&
            y >= p.cy - p.h / 2 - 4 && y <= p.cy + p.h / 2 + 4) {
          this.nm.selected = p.nm.id;
          this._syncNmSelection();
          this.render();
          if (!this._fromTouch) {
            var selEl = this.el.querySelector('.dsb__text-item[data-id="' + p.nm.id + '"]');
            if (selEl) selEl.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
          }
          return;
        }
      }
      this.nm.selected = null;
      this._syncNmSelection();
      this.render();
    },

    _renderNameplates: function () {
      var ctx = this.ctx, W = this.W, H = this.H;
      var self = this;

      // Light background
      ctx.fillStyle = '#f0ede8';
      ctx.fillRect(0, 0, W, H);

      // Subtle dot grid
      ctx.fillStyle = 'rgba(0,0,0,0.07)';
      for (var gx = 20; gx < W; gx += 22) {
        for (var gy = 20; gy < H; gy += 22) {
          ctx.beginPath(); ctx.arc(gx, gy, 0.8, 0, Math.PI * 2); ctx.fill();
        }
      }

      if (this.nm.items.length === 0) {
        ctx.font = '13px Helvetica Neue, Arial, sans-serif';
        ctx.fillStyle = 'rgba(0,0,0,0.3)';
        ctx.textAlign = 'center';
        ctx.textBaseline = 'middle';
        ctx.fillText('Add nameplates to preview them here', W / 2, H / 2);
        // Hide board nav when empty
        var emptyNav = this.el.querySelector('[data-board-nav]');
        if (emptyNav) emptyNav.style.display = 'none';
        return;
      }

      // ── Pagination: compute which items belong to which page ─────────────────
      var pageInfo = this._computeNmPages();
      var totalPages = pageInfo.total;
      // Clamp current page
      if (this.nm.page >= totalPages) this.nm.page = totalPages - 1;
      if (this.nm.page < 0) this.nm.page = 0;
      var curPage = this.nm.page;

      // Update board nav label and button states
      var boardNav  = this.el.querySelector('[data-board-nav]');
      var boardLbl  = this.el.querySelector('[data-board-label]');
      var prevBtn   = this.el.querySelector('[data-board-prev]');
      var nextBtn   = this.el.querySelector('[data-board-next]');
      if (boardNav)  boardNav.style.display  = 'flex';
      if (boardLbl)  boardLbl.textContent    = 'Board ' + (curPage + 1) + ' / ' + totalPages;
      if (prevBtn)   prevBtn.disabled        = (curPage === 0);
      if (nextBtn)   nextBtn.disabled        = (curPage >= totalPages - 1);

      // Filter to current page items
      var pageItems = this.nm.items.filter(function (nm) { return pageInfo.map[nm.id] === curPage; });

      // ── Render current page items ────────────────────────────────────────────
      var NP_DIMS = { small: [100, 30], medium: [140, 38], large: [200, 44] };
      var GAP = 14, PAD_X = 18, PAD_Y = 18;
      var x = PAD_X, y = PAD_Y, rowH = 0;

      this._nmPositions = [];

      pageItems.forEach(function (nm) {
        var dims = NP_DIMS[nm.size] || NP_DIMS.medium;
        var npw = dims[0], nph = dims[1];

        if (x + npw > W - PAD_X && x > PAD_X) {
          x = PAD_X; y += rowH + GAP; rowH = 0;
        }

        var cx = x + npw / 2, cy = y + nph / 2;
        x += npw + GAP;
        rowH = Math.max(rowH, nph);
        self._nmPositions.push({ nm: nm, cx: cx, cy: cy, w: npw, h: nph });

        var npx = cx - npw / 2, npy = cy - nph / 2;
        var corner = nm.corner || 'rounded';
        var r = corner === 'square' ? 0 : corner === 'pill' ? nph / 2 : 4;
        var npHex = self._npColorHex(nm.npColorId || 'matte-black');

        ctx.save();
        ctx.shadowColor = 'rgba(0,0,0,0.2)';
        ctx.shadowBlur = 8;
        ctx.shadowOffsetY = 3;

        ctx.beginPath();
        if (r === 0) {
          ctx.rect(npx, npy, npw, nph);
        } else {
          ctx.moveTo(npx + r, npy);
          ctx.lineTo(npx + npw - r, npy);
          ctx.quadraticCurveTo(npx + npw, npy, npx + npw, npy + r);
          ctx.lineTo(npx + npw, npy + nph - r);
          ctx.quadraticCurveTo(npx + npw, npy + nph, npx + npw - r, npy + nph);
          ctx.lineTo(npx + r, npy + nph);
          ctx.quadraticCurveTo(npx, npy + nph, npx, npy + nph - r);
          ctx.lineTo(npx, npy + r);
          ctx.quadraticCurveTo(npx, npy, npx + r, npy);
          ctx.closePath();
        }

        var ng = ctx.createLinearGradient(npx, npy, npx, npy + nph);
        ng.addColorStop(0, self._lighten(npHex, 0.10));
        ng.addColorStop(1, self._darken(npHex, 0.10));
        ctx.fillStyle = ng;
        ctx.fill();
        ctx.shadowColor = 'transparent';

        ctx.save();
        ctx.clip();
        var sh = ctx.createLinearGradient(npx, npy, npx, npy + nph * 0.5);
        sh.addColorStop(0, 'rgba(255,255,255,0.18)');
        sh.addColorStop(1, 'rgba(255,255,255,0)');
        ctx.fillStyle = sh;
        ctx.fillRect(npx, npy, npw, nph);
        ctx.restore();
        ctx.restore();

        if (self.nm.selected === nm.id) {
          ctx.strokeStyle = '#c8a96e';
          ctx.lineWidth = 1.5;
          ctx.setLineDash([4, 3]);
          ctx.strokeRect(npx - 4, npy - 4, npw + 8, nph + 8);
          ctx.setLineDash([]);
        }

        if (nm.nfc) {
          ctx.font = 'bold 7px Helvetica Neue, Arial, sans-serif';
          ctx.fillStyle = '#c8a96e';
          ctx.textAlign = 'right';
          ctx.textBaseline = 'top';
          ctx.fillText('NFC', npx + npw - 3, npy + 3);
        }

        var ts = Math.min(nm.textSize || 16, nph * 0.60);
        ctx.font = self._fontStr(nm.font, nm.bold, nm.italic, ts);
        ctx.fillStyle = self._tcHex(nm.colorId || 'white');
        ctx.textAlign = 'center';
        ctx.textBaseline = 'middle';
        ctx.fillText(nm.text, cx, cy, npw - 14);
      });
    },

    _buildNmConfig: function () {
      var self = this;
      return {
        system:  'nameplates',
        version: 1,
        items: this.nm.items.map(function (nm, i) {
          var tcObj = TEXT_COLORS.filter(function (c) { return c.id === nm.colorId; })[0];
          var bgObj = NP_COLORS.filter(function (c) { return c.id === nm.npColorId; })[0];
          return {
            index:        i + 1,
            text:         nm.text,
            tileSize:     nm.size,
            corner:       nm.corner || 'rounded',
            font:         nm.font,
            textSizePx:   nm.textSize,
            bold:         nm.bold,
            italic:       nm.italic,
            textColorId:  nm.colorId,
            textColorHex: tcObj ? tcObj.hex : '#f5f0e8',
            bgColorId:    nm.npColorId,
            bgColorHex:   bgObj ? bgObj.hex : '#1a1a1a',
            nfc:          nm.nfc,
            nfcUrl:       nm.nfc ? nm.nfcUrl : null,
            extraCost:    (NP_EXTRA_PRICES[nm.size] || 5) + (nm.nfc ? (ADDON_PRICES.nfcEmbed || 25) : 0),
          };
        }),
        generatedAt: new Date().toISOString(),
      };
    },

    // ── Price ─────────────────────────────────────────────────────────────────

    _updatePrice: function () {
      var total = this._calcTotal();
      var parts = [];

      if (this.mode === 'core') {
        parts.push('Core — ' + (this.core.size === 'S' ? 'Small' : this.core.size === 'M' ? 'Medium' : 'Large'));
        if (this.core.addons.nfcEmbed)  parts.push('+ NFC');
        if (this.core.addons.keychain)  parts.push('+ Keychain' + (this.core.keychainType === '3pack' ? ' 3-Pack' : ''));
        if (this.core.addons.bizcard)   parts.push('+ Business Card');
      } else if (this.mode === 'pro') {
        parts.push(this.pro.variant === 'moss' ? 'Pro — Moss Border' : 'Pro — Standard');
        if (this.pro.nameplates.length > NP_FREE_LIMIT) {
          parts.push('+ ' + (this.pro.nameplates.length - NP_FREE_LIMIT) + ' extra nameplates');
        }
        var proNfcCount = this.pro.nameplates.filter(function (np) { return np.nfc; }).length;
        if (proNfcCount > 0) parts.push('+ ' + proNfcCount + ' NFC');
        if (this.pro.addons.keychain)   parts.push('+ Keychain' + (this.pro.keychainType === '3pack' ? ' 3-Pack' : ''));
        if (this.pro.addons.bizcard)    parts.push('+ Business Card');
      } else {
        parts.push('Nameplates \u00d7' + this.nm.items.length);
        var nmNfcCount = this.nm.items.filter(function (np) { return np.nfc; }).length;
        if (nmNfcCount > 0) parts.push('+ ' + nmNfcCount + ' NFC');
      }

      // Rapid assembly fee = 10% of base total, min $5
      var rapidFee = this._rapidAssembly ? Math.max(5, Math.round(total * 0.10)) : 0;
      var displayTotal = total + rapidFee;

      var amtEl = this.el.querySelector('.dsb__price-amount');
      var lblEl = this.el.querySelector('.dsb__price-label');
      var feeEl = this.el.querySelector('.dsb__rapid-fee');
      if (amtEl) amtEl.textContent = '$' + displayTotal;
      if (lblEl) lblEl.textContent = parts.join(' ') + (this._rapidAssembly ? ' · Rapid Assembly' : '');
      if (feeEl) feeEl.textContent = '$' + Math.max(5, Math.round(total * 0.10));
      this._updateMobileBar();
    },

    // ── Cart ─────────────────────────────────────────────────────────────────

    _bindAtc: function () {
      var self = this;
      var btn = this.el.querySelector('.dsb__atc-btn');
      if (btn) btn.addEventListener('click', function () { self._addToCart(btn); });
    },

    _bindRapid: function () {
      var self = this;
      var label = this.el.querySelector('.dsb__rapid');
      var cb    = this.el.querySelector('.dsb__rapid-cb');
      if (!label || !cb) return;
      label.addEventListener('click', function (e) {
        e.preventDefault();
        self._rapidAssembly = !self._rapidAssembly;
        cb.checked = self._rapidAssembly;
        label.classList.toggle('dsb__rapid--active', self._rapidAssembly);
        self._updatePrice();
      });
    },

    _calcTotal: function () {
      var total = 0;
      if (this.mode === 'core') {
        total = CORE_PRICES[this.core.size] || 79;
        if (this.core.addons.nfcEmbed)  total += ADDON_PRICES.nfcEmbed;
        if (this.core.addons.keychain)  total += (this.core.keychainType === '3pack' ? ADDON_PRICES.keychain3pack : ADDON_PRICES.keychain);
        if (this.core.addons.bizcard)   total += ADDON_PRICES.bizcard;
      } else if (this.mode === 'pro') {
        total = PRO_PRICES[this.pro.variant] || 169;
        if (this.pro.nameplates.length > NP_FREE_LIMIT) {
          this.pro.nameplates.slice(NP_FREE_LIMIT).forEach(function (np) {
            total += NP_EXTRA_PRICES[np.size] || NP_EXTRA_PRICES.medium;
          });
        }
        var proNfc = this.pro.nameplates.filter(function (np) { return np.nfc; }).length;
        total += proNfc * ADDON_PRICES.nfcEmbed;
        if (this.pro.addons.keychain)   total += (this.pro.keychainType === '3pack' ? ADDON_PRICES.keychain3pack : ADDON_PRICES.keychain);
        if (this.pro.addons.bizcard)    total += ADDON_PRICES.bizcard;
      } else {
        this.nm.items.forEach(function (np) {
          total += NP_EXTRA_PRICES[np.size] || NP_EXTRA_PRICES.medium;
          if (np.nfc) total += ADDON_PRICES.nfcEmbed || 25;
        });
      }
      return total;
    },

    _showNpWarning: function (remaining, btn) {
      var self = this;
      var modal = this.el.querySelector('.dsb__np-warn');
      if (!modal) return;
      var msg = modal.querySelector('.dsb__np-warn-msg');
      if (msg) {
        msg.textContent = 'You still have ' + remaining + ' free nameplate' + (remaining === 1 ? '' : 's') + ' remaining — your board includes 12 at no extra charge.';
      }
      modal.classList.remove('dsb__np-warn--hidden');
      modal.querySelector('.dsb__np-warn-back').onclick = function () {
        modal.classList.add('dsb__np-warn--hidden');
      };
      modal.querySelector('.dsb__np-warn-continue').onclick = function () {
        modal.classList.add('dsb__np-warn--hidden');
        self._doAddToCart(btn);
      };
    },

    _addToCart: function (btn) {
      // Pro mode: warn if they haven't used all their free nameplates
      if (this.mode === 'pro' && this.pro.nameplates.length < NP_FREE_LIMIT) {
        var remaining = NP_FREE_LIMIT - this.pro.nameplates.length;
        this._showNpWarning(remaining, btn);
        return;
      }
      this._doAddToCart(btn);
    },

    _doAddToCart: function (btn) {
      var self = this;
      var items = [];
      var errorMsg = null;

      if (this.mode === 'nameplates') {
        var nmVid = this.products.nameplates ? this.products.nameplates.variantId : null;
        if (!nmVid) {
          errorMsg = 'Standalone nameplates are not yet available for online ordering. Please contact us.';
        } else {
          var nmConfig = this._buildNmConfig();
          var nmTotal = this.nm.items.length;
          var nmSzCount = { small: 0, medium: 0, large: 0 };
          this.nm.items.forEach(function (nm) { nmSzCount[nm.size] = (nmSzCount[nm.size] || 0) + 1; });
          var nmSzParts = [];
          if (nmSzCount.small)  nmSzParts.push('Small \u00d7' + nmSzCount.small);
          if (nmSzCount.medium) nmSzParts.push('Medium \u00d7' + nmSzCount.medium);
          if (nmSzCount.large)  nmSzParts.push('Large \u00d7' + nmSzCount.large);
          var nmProps = {
            'System':     'Magnetic Nameplates',
            'Nameplates': nmTotal + ' total',
            'Sizes':      nmSzParts.join(' \u00b7 '),
          };
          nmProps['_config'] = JSON.stringify(nmConfig);
          items.push({ id: nmVid, quantity: this.nm.items.length, properties: nmProps });
          // Add NFC chips for enabled nameplates
          var nfcVid = this.products.nfcEmbed ? this.products.nfcEmbed.variantId : null;
          var nfcCount = this.nm.items.filter(function (nm) { return nm.nfc; }).length;
          if (nfcCount > 0 && nfcVid) items.push({ id: nfcVid, quantity: nfcCount });
        }
      } else if (this.mode === 'core') {
        var vid = this._coreVariantId();
        if (!vid) {
          errorMsg = 'Core Display is not yet available for online ordering. Please contact us to order.';
        } else {
          var sizeLabel = this.core.size === 'S' ? 'Small' : this.core.size === 'M' ? 'Medium' : 'Large';
          var cornerLabel = this.core.corner.charAt(0).toUpperCase() + this.core.corner.slice(1);
          var bgName = this._bgColorName(this.core.bgColorId);
          var config = this._buildCoreConfig();

          // Human-readable properties — visible on Shopify order page + customer receipt
          var props = {
            'System':            'Core Display',
            'Size':              sizeLabel,
            'Corner Style':      cornerLabel,
            'Background Color':  bgName,
            'Finish':            'Resin',
            'Text Blocks':       String(this.core.textBlocks.length),
          };

          // Per text block — readable at a glance in the order
          this.core.textBlocks.forEach(function (b, i) {
            var n = i + 1;
            var pos = self._normalizeCoreCoords(b);
            var fontName = FONTS.filter(function (f) { return f.id === b.font; })[0];
            var fontLabel = fontName ? fontName.name : b.font;
            var tcName = TEXT_COLORS.filter(function (c) { return c.id === b.colorId; })[0];
            var colorLabel = tcName ? tcName.name : b.colorId;
            props['Text ' + n] = b.text;
            props['Text ' + n + ' Style'] =
              fontLabel + ' · ' + b.size + 'px' +
              (b.bold   ? ' · Bold'   : '') +
              (b.italic ? ' · Italic' : '') +
              ' · ' + colorLabel +
              ' · X:' + pos.x + '% Y:' + pos.y + '%';
          });

          // Machine-readable full config — underscore prefix hides from customer receipt,
          // still visible in Shopify admin order view and accessible via Order webhook/API
          props['_config'] = JSON.stringify(config);

          items.push({ id: vid, quantity: 1, properties: props });

          if (this.core.addons.nfcEmbed && this.products.nfcEmbed && this.products.nfcEmbed.variantId) {
            items.push({ id: this.products.nfcEmbed.variantId, quantity: 1, properties: { 'For': 'Core Display' } });
          }
          if (this.core.addons.keychain && this.products.keychain && this.products.keychain.variantId) {
            var coreKcQty = this.core.keychainType === '3pack' ? 3 : 1;
            var coreKcProps = { 'For': 'Core Display', 'Type': this.core.keychainType === '3pack' ? '3-Pack' : 'Single' };
            items.push({ id: this.products.keychain.variantId, quantity: coreKcQty, properties: coreKcProps });
          }
          if (this.core.addons.bizcard && this.products.bizcard && this.products.bizcard.variantId) {
            var coreBcProps = { 'For': 'Core Display' };
            if (this.core.bizcardText) coreBcProps['Card Text'] = this.core.bizcardText;
            items.push({ id: this.products.bizcard.variantId, quantity: 1, properties: coreBcProps });
          }
        }
      } else {
        var pvid = this._proVariantId();
        if (!pvid) {
          errorMsg = 'Pro Display is not available for online ordering. Please contact us to order.';
        } else {
          var proConfig = this._buildProConfig();
          var npColorLabel = this._npColorName(this.pro.npColorId);
          var boardColorLabel = this._boardColorName(this.pro.boardColorId);

          var proNpCount = this.pro.nameplates.length;
          var proFree    = Math.min(proNpCount, NP_FREE_LIMIT);
          var proExtra   = Math.max(0, proNpCount - NP_FREE_LIMIT);
          var proSzCount = { small: 0, medium: 0, large: 0 };
          this.pro.nameplates.forEach(function (np) { proSzCount[np.size] = (proSzCount[np.size] || 0) + 1; });
          var proSzParts = [];
          if (proSzCount.small)  proSzParts.push('Small \u00d7' + proSzCount.small);
          if (proSzCount.medium) proSzParts.push('Medium \u00d7' + proSzCount.medium);
          if (proSzCount.large)  proSzParts.push('Large \u00d7' + proSzCount.large);

          var frameColorLabel = (FRAME_COLORS.filter(function (x) { return x.id === self.pro.frameColorId; })[0] || {}).name || 'Black';
          var proProps = {
            'System':          'Pro (Magnetic Board)',
            'Board Style':     this.pro.variant === 'moss' ? 'Moss Border' : 'Standard',
            'Frame Color':     frameColorLabel,
            'Board Color':     boardColorLabel,
            'Nameplate Color': npColorLabel,
            'Nameplates':      proFree + '/' + NP_FREE_LIMIT + ' free' + (proExtra > 0 ? ' + ' + proExtra + ' extra' : ''),
            'Sizes':           proSzParts.join(' \u00b7 '),
          };

          proProps['_config'] = JSON.stringify(proConfig);

          items.push({ id: pvid, quantity: 1, properties: proProps });

          if (this.pro.addons.keychain && this.products.keychain && this.products.keychain.variantId) {
            var proKcQty = this.pro.keychainType === '3pack' ? 3 : 1;
            var proKcProps = { 'For': 'Pro Display', 'Type': this.pro.keychainType === '3pack' ? '3-Pack' : 'Single' };
            items.push({ id: this.products.keychain.variantId, quantity: proKcQty, properties: proKcProps });
          }
          if (this.pro.addons.bizcard && this.products.bizcard && this.products.bizcard.variantId) {
            var proBcProps = { 'For': 'Pro Display' };
            if (this.pro.bizcardText) proBcProps['Card Text'] = this.pro.bizcardText;
            items.push({ id: this.products.bizcard.variantId, quantity: 1, properties: proBcProps });
          }
        }
      }

      if (errorMsg) { this._showError(errorMsg, btn); return; }
      if (!items.length) return;

      // Always stamp rapid assembly info as a property so it appears on the order
      var raFeeItem = null;
      if (this._rapidAssembly) {
        var baseTotal = this._calcTotal();
        var raFee = Math.max(5, Math.round(baseTotal * 0.10));
        if (!items[0].properties) items[0].properties = {};
        items[0].properties['Rapid Assembly'] = 'Yes \u2014 +$' + raFee + ' rush fee';
        items[0].properties['Estimated Ship Time'] = '2\u20133 business days';

        // Also build a separate fee line item so the cart total reflects the charge
        var raVid = this.products.rapidAssembly ? this.products.rapidAssembly.variantId : null;
        if (raVid) {
          raFeeItem = {
            id: raVid,
            quantity: raFee,   // product priced at $1/unit — qty = dollar amount
            properties: { 'Rush Fee': '10% of $' + baseTotal, '_rapid': 'true' }
          };
        }
      }

      btn.disabled    = true;
      btn.textContent = 'Adding\u2026';

      // Step 1 — add the main product(s)
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: items }),
      })
      .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, data: d }; }); })
      .then(function (res) {
        if (!res.ok || res.data.status) throw new Error(res.data.description || 'Cart error');

        // Step 2 — add rapid assembly fee as a separate line item if configured
        if (raFeeItem) {
          return fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: [raFeeItem] }),
          })
          .then(function (r2) { return r2.json().then(function (d2) { return { ok: r2.ok, data: d2 }; }); })
          .then(function (res2) {
            // If the fee product fails (e.g. inventory issue), still proceed — fee is in properties
            return true;
          });
        }
        return true;
      })
      .then(function () {
        btn.textContent = 'Added!';
        btn.disabled    = false;
        setTimeout(function () {
          btn.textContent = 'Add to Cart';
          // Show reassurance modal instead of hard redirect
          if (self._reassureModal) {
            self._reassureModal.classList.remove('dsb__reassure--hidden');
          } else {
            window.location.href = '/cart';
          }
        }, 600);
      })
      .catch(function () {
        btn.textContent = 'Add to Cart';
        btn.disabled    = false;
        self._showError('Could not add to cart. Please try again.', btn);
      });
    },

    // ── Config builders (full structured data for production/automation) ─────────

    _buildCoreConfig: function () {
      var self = this;
      // Canvas display dims match _renderCore
      var DIMS = { S: [130, 165], M: [175, 215], L: [215, 265] };
      var dim = DIMS[this.core.size] || DIMS.M;
      return {
        system:      'core',
        version:     1,
        size:        this.core.size,
        sizeMM:      this.core.size === 'S' ? '83x105' : this.core.size === 'M' ? '112x137' : '137x169',
        corner:      this.core.corner,
        bgColorId:   this.core.bgColorId,
        bgColorHex:  this._bgColorHex(this.core.bgColorId),
        bgColorName: this._bgColorName(this.core.bgColorId),
        finish:      'resin',
        displayPx:   { w: dim[0], h: dim[1] }, // canvas px dimensions of the display face
        textBlocks:  this.core.textBlocks.map(function (b) {
          var pos = self._normalizeCoreCoords(b);
          var tcName = TEXT_COLORS.filter(function (c) { return c.id === b.colorId; })[0];
          return {
            text:     b.text,
            font:     b.font,
            sizePx:   b.size,
            bold:     b.bold,
            italic:   b.italic,
            colorId:  b.colorId,
            colorHex: tcName ? tcName.hex : '#f5f0e8',
            // Normalized position: 0=left/top edge of display, 100=right/bottom edge
            xPct:     pos.x,
            yPct:     pos.y,
            // Raw canvas coords preserved for reference
            xCanvas:  Math.round(b.x),
            yCanvas:  Math.round(b.y),
          };
        }),
        addons: {
          nfcEmbed:      this.core.addons.nfcEmbed,
          keychain:      this.core.addons.keychain,
          keychainType:  this.core.keychainType,
          bizcard:       this.core.addons.bizcard,
          bizcardText:   this.core.bizcardText,
        },
        generatedAt: new Date().toISOString(),
      };
    },

    _buildProConfig: function () {
      var self = this;
      return {
        system:          'pro',
        version:         1,
        boardStyle:      this.pro.variant,
        orientation:     this.pro.orientation,
        boardSizeMM:     this.pro.orientation === 'landscape' ? '356x305' : '305x356',
        frameColorId:    this.pro.frameColorId,
        frameColorHex:   this._frameColorHex(this.pro.frameColorId),
        boardColorId:    this.pro.boardColorId,
        boardColorHex:   this._boardColorHex(this.pro.boardColorId),
        boardColorName:  this._boardColorName(this.pro.boardColorId),
        npColorId:       this.pro.npColorId,
        npColorHex:      this._npColorHex(this.pro.npColorId),
        npColorName:     this._npColorName(this.pro.npColorId),
        nameplateQuota: {
          included:    NP_FREE_LIMIT,
          used:        Math.min(this.pro.nameplates.length, NP_FREE_LIMIT),
          extra:       Math.max(0, this.pro.nameplates.length - NP_FREE_LIMIT),
          extraCost:   (function (nps) {
            var cost = 0;
            nps.slice(NP_FREE_LIMIT).forEach(function (np) { cost += NP_EXTRA_PRICES[np.size] || NP_EXTRA_PRICES.medium; });
            return cost;
          })(this.pro.nameplates),
        },
        nameplates: this.pro.nameplates.map(function (np, i) {
          var pos = self._normalizeProCoords(np);
          var tcName = TEXT_COLORS.filter(function (c) { return c.id === np.colorId; })[0];
          return {
            text:       np.text,
            tileSize:   np.size,
            corner:     np.corner || 'rounded',
            included:   i < NP_FREE_LIMIT,
            extraCost:  i >= NP_FREE_LIMIT ? (NP_EXTRA_PRICES[np.size] || NP_EXTRA_PRICES.medium) : 0,
            font:       np.font,
            textSizePx: np.textSize,
            bold:       np.bold,
            italic:     np.italic,
            colorId:    np.colorId,
            colorHex:   tcName ? tcName.hex : '#f5f0e8',
            xPct:       pos.x,
            yPct:       pos.y,
            xCanvas:    Math.round(np.x),
            yCanvas:    Math.round(np.y),
          };
        }),
        addons: {
          keychain:      this.pro.addons.keychain,
          keychainType:  this.pro.keychainType,
          bizcard:       this.pro.addons.bizcard,
          bizcardText:   this.pro.bizcardText,
        },
        generatedAt: new Date().toISOString(),
      };
    },

    // Convert canvas x/y to % of Core display face (0=top-left, 100=bottom-right)
    _normalizeCoreCoords: function (block) {
      var dims = this._getCoreDims();
      return {
        x: Math.round(((block.x - dims.dx) / dims.dw) * 100),
        y: Math.round(((block.y - dims.dy) / dims.dh) * 100),
      };
    },

    // Convert canvas x/y to % of Pro board face (0=top-left, 100=bottom-right)
    _normalizeProCoords: function (np) {
      var bw = 280, bh = 327;
      var bx = (this.W - bw) / 2, by = (this.H - bh) / 2;
      return {
        x: Math.round(((np.x - bx) / bw) * 100),
        y: Math.round(((np.y - by) / bh) * 100),
      };
    },

    _coreVariantId: function () {
      var p = this.products.core;
      if (!p) return null;
      if (this.core.size === 'S') return p.variantSmall;
      if (this.core.size === 'L') return p.variantLarge;
      return p.variantMedium;
    },

    _proVariantId: function () {
      var p = this.products.pro;
      if (!p) return null;
      return this.pro.variant === 'moss' ? p.variantMoss : p.variantStandard;
    },

    _showError: function (msg, btn) {
      var err = this.el.querySelector('.dsb__atc-error');
      if (!err) {
        err = document.createElement('div');
        err.className = 'dsb__atc-error';
        btn.parentNode.appendChild(err);
      }
      err.textContent = msg;
      err.style.display = 'block';
      setTimeout(function () { err.style.display = 'none'; }, 6000);
    },

    // ── Helpers ───────────────────────────────────────────────────────────────

    _filamentHex: function (id) {
      var f = FILAMENTS.filter(function (x) { return x.id === id; })[0];
      return f ? f.hex : '#1a1a1a';
    },

    _filamentName: function (id) {
      var f = FILAMENTS.filter(function (x) { return x.id === id; })[0];
      return f ? f.name : 'Forge Black';
    },

    _bgColorHex: function (id) {
      var c = BG_COLORS.filter(function (x) { return x.id === id; })[0];
      return c ? c.hex : '#1a1a1a';
    },

    _bgColorName: function (id) {
      var c = BG_COLORS.filter(function (x) { return x.id === id; })[0];
      return c ? c.name : 'Matte Black';
    },

    _boardColorHex: function (id) {
      var c = BOARD_COLORS.filter(function (x) { return x.id === id; })[0];
      return c ? c.hex : '#1e1e1e';
    },

    _boardColorName: function (id) {
      var c = BOARD_COLORS.filter(function (x) { return x.id === id; })[0];
      return c ? c.name : 'Black';
    },

    _frameColorHex: function (id) {
      var c = FRAME_COLORS.filter(function (x) { return x.id === id; })[0];
      return c ? c.hex : '#1a1a1a';
    },

    _npColorHex: function (id) {
      var c = NP_COLORS.filter(function (x) { return x.id === id; })[0];
      return c ? c.hex : '#1a1a1a';
    },

    _npColorName: function (id) {
      var c = NP_COLORS.filter(function (x) { return x.id === id; })[0];
      return c ? c.name : 'Matte Black';
    },

    _tcHex: function (id) {
      var c = TEXT_COLORS.filter(function (x) { return x.id === id; })[0];
      return c ? c.hex : '#f5f0e8';
    },

    _fontStr: function (id, bold, italic, size) {
      var f = FONTS.filter(function (x) { return x.id === id; })[0];
      var css = f ? f.css : 'Helvetica Neue, Arial, sans-serif';
      return (italic ? 'italic ' : '') + (bold ? 'bold ' : '') + size + 'px ' + css;
    },

    _lighten: function (hex, amt) {
      var rgb = this._hexRgb(hex);
      if (!rgb) return hex;
      return 'rgb(' + Math.min(255, rgb.r + Math.round(255 * amt)) + ',' +
                      Math.min(255, rgb.g + Math.round(255 * amt)) + ',' +
                      Math.min(255, rgb.b + Math.round(255 * amt)) + ')';
    },

    _darken: function (hex, amt) {
      var rgb = this._hexRgb(hex);
      if (!rgb) return hex;
      return 'rgb(' + Math.max(0, rgb.r - Math.round(255 * amt)) + ',' +
                      Math.max(0, rgb.g - Math.round(255 * amt)) + ',' +
                      Math.max(0, rgb.b - Math.round(255 * amt)) + ')';
    },

    _hexRgb: function (hex) {
      var m = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
      return m ? { r: parseInt(m[1], 16), g: parseInt(m[2], 16), b: parseInt(m[3], 16) } : null;
    },

    _isMobile: function () { return window.innerWidth < 990; },

    _openNpPanelForPlate: function (np) {
      var self = this;
      // Close any existing panel first
      this._closeNpPanel();
      // Use requestAnimationFrame to ensure DOM is clean, then open fresh and jump to the plate
      requestAnimationFrame(function () {
        self._openNpPanel();
        requestAnimationFrame(function () {
          var panel = self.el.querySelector('.dsb__np-slideup');
          if (panel) self._openInlineEdit(panel, np);
        });
      });
    },

    _openTextPanelForBlock: function (block) {
      var self = this;
      // Close any existing text panel first
      this._closeTextPanel();
      requestAnimationFrame(function () {
        self._openTextPanel();
        requestAnimationFrame(function () {
          var panel = self.el.querySelector('.dsb__text-slideup');
          if (!panel) return;
          // Mark tapped block as selected and scroll its item into view
          self.core.selected = block.id;
          self._syncCoreSelection();
          var list = panel.querySelector('.dsb__text-slideup-list');
          if (!list) return;
          list.querySelectorAll('.dsb__text-item').forEach(function (i) { i.classList.remove('active'); });
          var target = list.querySelector('.dsb__text-item[data-id="' + block.id + '"]');
          if (target) {
            target.classList.add('active');
            target.scrollIntoView({ behavior: 'smooth', block: 'center' });
          }
        });
      });
    },

    _esc: function (s) {
      return (s || '').replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/</g, '&lt;');
    },

    // Draw text curved upward along an arc. `curve` in [0..100]; 0 = straight.
    _drawCurvedText: function (ctx, text, cx, cy, size, curve) {
      if (!text) return;
      var intensity = Math.max(0, Math.min(100, curve)) / 100; // 0..1
      if (intensity === 0) { ctx.fillText(text, cx, cy); return; }

      var totalAngle = intensity * (Math.PI * 2 / 3); // up to 120°

      var chars = text.split('');
      var widths = chars.map(function (ch) { return ctx.measureText(ch).width; });
      var totalWidth = widths.reduce(function (a, b) { return a + b; }, 0);
      if (totalWidth <= 0) return;

      var radius = totalWidth / 2 / Math.sin(totalAngle / 2);
      var arcCx = cx;
      var arcCy = cy + radius; // center below → arc opens upward

      ctx.save();
      var startAngle = -Math.PI / 2 - totalAngle / 2;
      var anglePerWidth = totalAngle / totalWidth;
      var angle = startAngle;

      for (var i = 0; i < chars.length; i++) {
        var w = widths[i];
        var midAngle = angle + (w * anglePerWidth) / 2;
        var x = arcCx + radius * Math.cos(midAngle);
        var y = arcCy + radius * Math.sin(midAngle);
        ctx.save();
        ctx.translate(x, y);
        ctx.rotate(midAngle + Math.PI / 2);
        ctx.fillText(chars[i], 0, 0);
        ctx.restore();
        angle += w * anglePerWidth;
      }
      ctx.restore();
    },

  };

  // ── Boot ───────────────────────────────────────────────────────────────────
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-display-builder]').forEach(function (el) {
      new SSMadeDisplayBuilder(el);
    });
  });

})();
